(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3582],{

/***/ 77349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ addDays; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}

/***/ }),

/***/ 92300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ differenceInCalendarDays; }
/* harmony export */ });
/* harmony import */ var _lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24262);
/* harmony import */ var _startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69119);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



var MILLISECONDS_IN_DAY = 86400000;

/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var startOfDayLeft = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var startOfDayRight = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - (0,_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - (0,_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(startOfDayRight);

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

/***/ }),

/***/ 69119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ startOfDay; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 7069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ subDays; }
/* harmony export */ });
/* harmony import */ var _addDays_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77349);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);



/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addDays_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, -amount);
}

/***/ }),

/***/ 9933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ initConstants; }
/* harmony export */ });
/* harmony import */ var redux_actions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88231);
/* harmony import */ var main_javascripts_constants_actionType_ConstantActionType__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10338);


var initConstants = (0,redux_actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(main_javascripts_constants_actionType_ConstantActionType__WEBPACK_IMPORTED_MODULE_1__/* .INIT_CONSTANTS */ .C, function (param) {
  return {
    facebookAppId: param.facebookAppId
  };
});

/***/ }),

/***/ 86133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ sendLiffTextMessages; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50029);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);


function sendLiffTextMessages(_x, _x2, _x3, _x4) {
  return _sendLiffTextMessages.apply(this, arguments);
}

function _sendLiffTextMessages() {
  _sendLiffTextMessages = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(textMessages, liffId, success, error) {
    var messages;
    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            messages = textMessages.map(function (message) {
              return {
                type: "text",
                text: message
              };
            });

            if (!liffId) {
              _context.next = 4;
              break;
            }

            _context.next = 4;
            return liff.init({
              liffId: liffId
            });

          case 4:
            liff.sendMessages(messages).then(function () {
              if (success) {
                success();
              }
            })["catch"](function (err) {
              if (error) {
                error(err);
              }
            });

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _sendLiffTextMessages.apply(this, arguments);
}

/***/ }),

/***/ 20865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ BasicBlock; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var aphrodite__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34397);
/* harmony import */ var _BasicBlockStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60223);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);





var BasicBlockComponent = function BasicBlockComponent(props) {
  var styles = props.styles,
      children = props.children,
      _props$styleKey = props.styleKey,
      styleKey = _props$styleKey === void 0 ? "block" : _props$styleKey;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
    className: (0,aphrodite__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_BasicBlockStyle__WEBPACK_IMPORTED_MODULE_2__/* .BasicBlockStyle */ .V[styleKey], styles),
    children: children
  });
};

var BasicBlock = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(BasicBlockComponent);

/***/ }),

/***/ 60223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ BasicBlockStyle; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59499);
/* harmony import */ var aphrodite__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34397);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88433);
/* harmony import */ var main_javascripts_styles_base_maxWidthStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79105);





var BasicBlockStyle = aphrodite__WEBPACK_IMPORTED_MODULE_0__/* .StyleSheet.create */ .mM.create({
  block: {
    padding: "".concat(main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block2x */ .D.block2x, " ").concat(main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block */ .D.block),
    maxWidth: main_javascripts_styles_base_maxWidthStyle__WEBPACK_IMPORTED_MODULE_3__/* .maxWidth.page1col */ .k.page1col,
    margin: "0 auto",
    boxSizing: "border-box"
  },
  blockWide: {
    padding: "".concat(main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block2x */ .D.block2x, " ").concat(main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block */ .D.block),
    maxWidth: main_javascripts_styles_base_maxWidthStyle__WEBPACK_IMPORTED_MODULE_3__/* .maxWidth.page1colWide */ .k.page1colWide,
    margin: "0 auto",
    boxSizing: "border-box"
  },
  blockFullWidth: {
    padding: "".concat(main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block2x */ .D.block2x, " 0"),
    maxWidth: "100%",
    boxSizing: "border-box"
  },
  blockMultiCol: (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_2__/* .moreThanBreakpoint */ .h6)("desktop"), {
    padding: "".concat(main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block2x */ .D.block2x, " ").concat(main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.block */ .D.block),
    margin: "0 auto",
    maxWidth: main_javascripts_styles_base_maxWidthStyle__WEBPACK_IMPORTED_MODULE_3__/* .maxWidth.page2col */ .k.page2col,
    boxSizing: "border-box"
  })
});

/***/ }),

/***/ 98034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* reexport safe */ _BasicBlock__WEBPACK_IMPORTED_MODULE_1__.M; }
/* harmony export */ });
/* harmony import */ var _BasicBlockStyle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60223);
/* harmony import */ var _BasicBlock__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20865);



/***/ }),

/***/ 77479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ MainBlock; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var aphrodite__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34397);
/* harmony import */ var _MainBlockStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36745);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);


var _excluded = ["styles", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var MainBlock = function MainBlock(props) {
  var styles = props.styles,
      children = props.children,
      rest = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, _excluded);

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", _objectSpread(_objectSpread({
    className: (0,aphrodite__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_MainBlockStyle__WEBPACK_IMPORTED_MODULE_3__/* .MainBlockStyle.block */ .d.block, styles)
  }, rest), {}, {
    children: children
  }));
};

/***/ }),

/***/ 36745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ MainBlockStyle; }
/* harmony export */ });
/* harmony import */ var aphrodite__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34397);

var MainBlockStyle = aphrodite__WEBPACK_IMPORTED_MODULE_0__/* .StyleSheet.create */ .mM.create({
  block: {
    boxSizing: "border-box"
  }
});

/***/ }),

/***/ 59941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* reexport safe */ _MainBlock__WEBPACK_IMPORTED_MODULE_1__.R; }
/* harmony export */ });
/* harmony import */ var _MainBlockStyle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36745);
/* harmony import */ var _MainBlock__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77479);



/***/ }),

/***/ 27318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ CardTitle; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var aphrodite__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34397);
/* harmony import */ var _CardStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39587);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);


var _excluded = ["styles", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var CardTitle = function CardTitle(props) {
  var styles = props.styles,
      children = props.children,
      rest = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, _excluded);

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", _objectSpread(_objectSpread({
    className: (0,aphrodite__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_CardStyle__WEBPACK_IMPORTED_MODULE_3__/* .CardStyle.cardTitle */ .U.cardTitle, styles)
  }, rest), {}, {
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("h3", {
      className: (0,aphrodite__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_CardStyle__WEBPACK_IMPORTED_MODULE_3__/* .CardStyle.cardTitleText */ .U.cardTitleText),
      children: children
    })
  }));
};

/***/ }),

/***/ 99374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ GoogleMap; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./node_modules/google-maps-react/dist/index.js
var dist = __webpack_require__(95642);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/borderStyle.ts
var borderStyle = __webpack_require__(58589);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/GoogleMap/GoogleMapStyle.ts



var mapContainerStyle = {
  top: 0,
  left: 0
};
var GoogleMapStyle = es/* StyleSheet.create */.mM.create({
  googleMap: {
    margin: spaceStyle/* space.atom */.D.atom,
    width: "auto",
    paddingTop: "50%",
    borderRadius: borderStyle/* borderRadius.normal */.E.normal,
    position: "relative"
  }
});
// EXTERNAL MODULE: ./main/javascripts/constants/Constants.ts
var Constants = __webpack_require__(25968);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/GoogleMap/GoogleMap.tsx







var GoogleMapComponent = function GoogleMapComponent(props) {
  var google = props.google,
      latitude = props.latitude,
      longitude = props.longitude;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    className: (0,es/* css */.iv)(GoogleMapStyle.googleMap),
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist.Map, {
      containerStyle: mapContainerStyle,
      google: google,
      zoom: 14,
      streetViewControl: false,
      fullscreenControl: true,
      mapTypeControl: false,
      initialCenter: {
        lat: latitude,
        lng: longitude
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist.Marker, {})
    })
  });
};

var GoogleMap = (0,dist.GoogleApiWrapper)({
  apiKey: Constants/* GOOGLE_API_KEY */.JO,
  language: "ja",
  region: "JP"
})(GoogleMapComponent);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/GoogleMap/index.ts


/***/ }),

/***/ 3007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H1": function() { return /* reexport */ H1; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/H1/H1Style.ts




var H1Style = es/* StyleSheet.create */.mM.create({
  h1: {
    fontSize: typographyStyle/* fontSize.title */.JB.title,
    lineHeight: typographyStyle/* lineHeight.title */.Nv.title,
    fontWeight: typographyStyle/* fontWeight.bold */.Ue.bold,
    color: colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor,
    padding: "calc(".concat(spaceStyle/* space.atom */.D.atom, " - (").concat(typographyStyle/* lineHeight.title */.Nv.title, " - ").concat(typographyStyle/* fontSize.title */.JB.title, ")/2) ").concat(spaceStyle/* space.atom */.D.atom),
    margin: 0
  }
});
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/H1/H1.tsx




var H1 = function H1(props) {
  var styles = props.styles,
      children = props.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
    className: (0,es/* css */.iv)(H1Style.h1, styles),
    children: children
  });
};
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/H1/index.ts


/***/ }),

/***/ 84026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H2": function() { return /* reexport */ H2; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/H2/H2Style.ts




var H2Style = es/* StyleSheet.create */.mM.create({
  h2: {
    fontSize: typographyStyle/* fontSize.headline */.JB.headline,
    lineHeight: typographyStyle/* lineHeight.headline2 */.Nv.headline2,
    fontWeight: typographyStyle/* fontWeight.regular */.Ue.regular,
    color: colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor,
    padding: "calc(".concat(spaceStyle/* space.atom */.D.atom, " - (").concat(typographyStyle/* lineHeight.headline2 */.Nv.headline2, " - ").concat(typographyStyle/* fontSize.headline */.JB.headline, ")/2) ").concat(spaceStyle/* space.atom */.D.atom),
    margin: 0
  }
});
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/H2/H2.tsx




var H2 = function H2(props) {
  var styles = props.styles,
      children = props.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
    className: (0,es/* css */.iv)(H2Style.h2, styles),
    children: children
  });
};
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/H2/index.ts


/***/ }),

/***/ 28075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ HorizontalRule; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/HorizontalRule/HorizontalRuleStyle.ts


var HorizontalRuleStyle = es/* StyleSheet.create */.mM.create({
  horizontalRule: {
    padding: "".concat(spaceStyle/* space.atom */.D.atom, " ").concat(spaceStyle/* space.atom */.D.atom, " 0"),
    margin: "".concat(spaceStyle/* space.atom */.D.atom, " ").concat(spaceStyle/* space.atom */.D.atom, " 0"),
    boxSizing: "border-box",
    borderStyle: "dashed"
  }
});
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/HorizontalRule/HorizontalRule.tsx




var HorizontalRule = function HorizontalRule(props) {
  var horizontalRuleStyle = props.styles ? props.styles.horizontalRule : null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("hr", {
    className: (0,es/* css */.iv)(HorizontalRuleStyle.horizontalRule, horizontalRuleStyle)
  });
};
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/HorizontalRule/index.ts


/***/ }),

/***/ 18339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ StarRating; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/StarRating/StarRatingStyle.ts




var StarRatingStyle = es/* StyleSheet.create */.mM.create({
  starRating: {
    color: colorStyle/* accentColor.starColor */.z.starColor,
    overflow: "hidden",
    margin: 0,
    lineHeight: 1
  },
  starPositive: {
    position: "absolute",
    top: 0,
    left: 0
  },
  iconBlock: {
    position: "relative",
    display: "inline-block",
    verticalAlign: "middle"
  },
  num: {
    fontSize: typographyStyle/* fontSize.caption */.JB.caption,
    lineHeight: typographyStyle/* lineHeight.noSpace */.Nv.noSpace,
    color: colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor,
    display: "inline-block",
    verticalAlign: "middle",
    padding: "0 0 0 ".concat(spaceStyle/* space.atom0_5x */.D.atom0_5x),
    letterSpacing: "0.05em"
  },
  block: {
    position: "relative",
    fontSize: typographyStyle/* fontSize.body */.JB.body,
    padding: spaceStyle/* space.atom */.D.atom,
    lineHeight: 0.1
  }
});
// EXTERNAL MODULE: ./main/javascripts/styles/fontStyle.ts + 3 modules
var fontStyle = __webpack_require__(6900);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/StarRating/StarRating.tsx


var _excluded = ["rating", "styles"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var getStarStyle = function getStarStyle(rating) {
  var starVal = Math.floor(rating * 2) / 2;
  var starString = "star".concat(starVal.toString().replace(".", "_"));
  return fontStyle/* StarStyle */.Nh[starString];
};

var StarRating = function StarRating(props) {
  var rating = props.rating,
      _props$styles = props.styles,
      styles = _props$styles === void 0 ? {} : _props$styles,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  var block = styles.block,
      iconBlock = styles.iconBlock;

  if (rating === 0) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", _objectSpread(_objectSpread({
    className: (0,es/* css */.iv)(StarRatingStyle.block, block)
  }, rest), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: (0,es/* css */.iv)(StarRatingStyle.iconBlock, iconBlock),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: (0,es/* css */.iv)(StarRatingStyle.starRating, fontStyle/* StarStyle.starEmpty */.Nh.starEmpty)
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: (0,es/* css */.iv)(StarRatingStyle.starRating, StarRatingStyle.starPositive, getStarStyle(rating))
      })]
    })
  }));
};
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/StarRating/index.ts


/***/ }),

/***/ 99615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* unused harmony export cardStyle */
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88433);
/* harmony import */ var main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58589);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96749);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);


var _excluded = ["children", "minHeightStyle", "styleKey", "overflowStyle", "borderStyle", "marginStyle"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var Card = function Card(props) {
  var children = props.children,
      _props$minHeightStyle = props.minHeightStyle,
      minHeightStyle = _props$minHeightStyle === void 0 ? "188px" : _props$minHeightStyle,
      _props$styleKey = props.styleKey,
      styleKey = _props$styleKey === void 0 ? "card" : _props$styleKey,
      _props$overflowStyle = props.overflowStyle,
      overflowStyle = _props$overflowStyle === void 0 ? "hidden" : _props$overflowStyle,
      _props$borderStyle = props.borderStyle,
      borderStyle = _props$borderStyle === void 0 ? "none" : _props$borderStyle,
      marginStyle = props.marginStyle,
      rest = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(props, _excluded);

  var cardStyles = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(cardStyle[styleKey], ";min-height:", minHeightStyle, ";overflow:", overflowStyle, ";border:", borderStyle, ";", marginStyle && "margin: ".concat(marginStyle, ";"), ";" + ( true ? "" : 0),  true ? "" : 0);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", _objectSpread(_objectSpread({
    css: cardStyles
  }, rest), {}, {
    children: children
  }));
};
var cardBaseStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)("display:flex;flex-direction:column;min-height:188px;overflow:hidden;position:relative;background:rgb(255, 255, 255);border-radius:", main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_3__/* .borderRadius.normal */ .E.normal, ";box-sizing:border-box;margin:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom2x */ .D.atom2x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_4__/* .space.atom */ .D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var cardStyle = {
  card: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(cardBaseStyle, ";", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_2__/* .moreThanBreakpoint */ .h6)("tablet"), "{flex-direction:row;}" + ( true ? "" : 0),  true ? "" : 0),
  cardNoHover: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(cardBaseStyle, ";", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_2__/* .moreThanBreakpoint */ .h6)("tablet"), "{flex-direction:row;}" + ( true ? "" : 0),  true ? "" : 0)
};

/***/ }),

/***/ 65562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ HotelDatePickerBlock; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(16835);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(70917);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(87536);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(32912);
/* harmony import */ var react_fast_compare__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69590);
/* harmony import */ var react_fast_compare__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_fast_compare__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26793);
/* harmony import */ var main_javascripts_components_hotel_form_CheckinInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27114);
/* harmony import */ var main_javascripts_components_hotel_form_CheckoutInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82011);
/* harmony import */ var main_javascripts_components_molecules_Modal_FullScreenModalDialog__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19484);
/* harmony import */ var main_javascripts_components_molecules_DatePicker__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31264);
/* harmony import */ var main_javascripts_constants_HotelConstants__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(10780);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88433);
/* harmony import */ var main_javascripts_components_molecules_DatePicker_HorizontalDatePicker__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16201);
/* harmony import */ var main_javascripts_constants_DateTypes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71797);
/* harmony import */ var main_javascripts_utils_DateUtil__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(16341);
/* harmony import */ var _styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96749);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14416);
/* harmony import */ var _utils_googleTagManagerUtil__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(49224);
/* harmony import */ var _constants_GoogleTagManagerEventTypes__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(12327);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(35944);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }























var HotelDatePickerBlockComponent = function HotelDatePickerBlockComponent(props) {
  var _props$labelColorStyl = props.labelColorStyleKey,
      labelColorStyleKey = _props$labelColorStyl === void 0 ? "default" : _props$labelColorStyl,
      borderColorStyleKey = props.borderColorStyleKey,
      disableStopBodyScrolling = props.disableStopBodyScrolling;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_13__/* .useTranslation */ .$)(["component"]),
      t = _useTranslation.t; // TODO: 旧reducerをそのまま使用


  var breakpoint = (0,react_redux__WEBPACK_IMPORTED_MODULE_10__/* .useSelector */ .v9)(function (state) {
    return state.breakpointReducer.breakpoint;
  });

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_14__/* .useFormContext */ .Gc)(),
      setValue = _useFormContext.setValue,
      control = _useFormContext.control,
      trigger = _useFormContext.trigger;

  var _useWatch = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_14__/* .useWatch */ .qo)({
    control: control,
    name: ["checkin_date", "checkout_date"]
  }),
      _useWatch2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_useWatch, 2),
      checkinDateValue = _useWatch2[0],
      checkoutDateValue = _useWatch2[1];

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      displayedPicker = _useState[0],
      setDisplayedPicker = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      pickerDateType = _useState2[0],
      setPickerDateType = _useState2[1];

  var inputCheckInRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var inputCheckOutRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(); // public shouldComponentUpdate(nextProps: any, nextState: any): boolean {
  //   return !isEqual(props, nextProps) || !isEqual(state, nextState);
  // }

  var onClickCheckinDate = function onClickCheckinDate() {
    setDisplayedPicker(true);
    setPickerDateType(main_javascripts_constants_DateTypes__WEBPACK_IMPORTED_MODULE_8__/* .DateTypes.fromDate */ .t.fromDate);
  };

  var onClickCheckoutDate = function onClickCheckoutDate() {
    setDisplayedPicker(true);
    setPickerDateType(main_javascripts_constants_DateTypes__WEBPACK_IMPORTED_MODULE_8__/* .DateTypes.toDate */ .t.toDate);
  };

  var sendDateEvent = function sendDateEvent(checkinDateString, checkoutDateString) {
    if (checkinDateString && checkoutDateString) {
      (0,_utils_googleTagManagerUtil__WEBPACK_IMPORTED_MODULE_11__/* .event */ .B)(_constants_GoogleTagManagerEventTypes__WEBPACK_IMPORTED_MODULE_12__/* .GoogleTagManagerEventTypes.date */ .T.date, {
        start_date: checkinDateString,
        end_date: checkoutDateString
      });
    }
  };

  var onComplete = function onComplete(startDate, endDate) {
    var checkinDateString = "";
    var checkoutDateString = "";

    if (startDate) {
      checkinDateString = (0,date_fns__WEBPACK_IMPORTED_MODULE_16__["default"])(startDate, "yyyy/LL/dd");
      setValue("checkin_date", checkinDateString);
      void trigger(["checkin_date"]);
    }

    if (endDate) {
      checkoutDateString = (0,date_fns__WEBPACK_IMPORTED_MODULE_16__["default"])(endDate, "yyyy/LL/dd");
      setValue("checkout_date", checkoutDateString);
      void trigger(["checkout_date"]);
    }

    sendDateEvent(checkinDateString, checkoutDateString);
    hidePicker();
  };

  var onUpdate = function onUpdate(startDate, endDate, isEndStep) {
    var checkinDateString = "";
    var checkoutDateString = "";

    if (startDate) {
      checkinDateString = (0,date_fns__WEBPACK_IMPORTED_MODULE_16__["default"])(startDate, "yyyy/LL/dd");
      setValue("checkin_date", checkinDateString);
      void trigger(["checkin_date"]);
    }

    if (endDate) {
      checkoutDateString = (0,date_fns__WEBPACK_IMPORTED_MODULE_16__["default"])(endDate, "yyyy/LL/dd");
      setValue("checkout_date", checkoutDateString);
      void trigger(["checkout_date"]);
    }

    if (!isEndStep) {
      setPickerDateType(main_javascripts_constants_DateTypes__WEBPACK_IMPORTED_MODULE_8__/* .DateTypes.toDate */ .t.toDate);
    }

    sendDateEvent(checkinDateString, checkoutDateString);
  };

  var hidePicker = function hidePicker() {
    setDisplayedPicker(false);
    setPickerDateType(null);
  }; // 再レンダリングの負荷が高い場合はメモ化検討する


  var fromDate = checkinDateValue ? (0,main_javascripts_utils_DateUtil__WEBPACK_IMPORTED_MODULE_17__/* .parseDate */ .s)(checkinDateValue) : null;
  var toDate = checkoutDateValue ? (0,main_javascripts_utils_DateUtil__WEBPACK_IMPORTED_MODULE_17__/* .parseDate */ .s)(checkoutDateValue) : null;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)("div", {
    css: blockStyle,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)("div", {
      css: inputBlockStyle,
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(main_javascripts_components_hotel_form_CheckinInput__WEBPACK_IMPORTED_MODULE_2__/* .CheckinInput */ .a, {
        namespace: "hotel",
        isActive: pickerDateType === main_javascripts_constants_DateTypes__WEBPACK_IMPORTED_MODULE_8__/* .DateTypes.fromDate */ .t.fromDate,
        onClick: onClickCheckinDate,
        labelColorStyleKey: labelColorStyleKey,
        borderColorStyleKey: borderColorStyleKey,
        inputBlockRef: inputCheckInRef
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(main_javascripts_components_hotel_form_CheckoutInput__WEBPACK_IMPORTED_MODULE_3__/* .CheckoutInput */ .a, {
        namespace: "hotel",
        isActive: pickerDateType === main_javascripts_constants_DateTypes__WEBPACK_IMPORTED_MODULE_8__/* .DateTypes.toDate */ .t.toDate,
        onClick: onClickCheckoutDate,
        labelColorStyleKey: labelColorStyleKey,
        borderColorStyleKey: borderColorStyleKey,
        inputBlockRef: inputCheckOutRef
      })]
    }), (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_6__/* .isPhone */ .Mn)(breakpoint) ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(main_javascripts_components_molecules_Modal_FullScreenModalDialog__WEBPACK_IMPORTED_MODULE_4__/* .FullScreenModalDialog */ .H, {
      displayed: displayedPicker,
      closeHandler: hidePicker,
      colorMode: "light",
      disableStopBodyScrolling: disableStopBodyScrolling,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(main_javascripts_components_molecules_DatePicker__WEBPACK_IMPORTED_MODULE_5__/* .ScrollableDatePicker */ .d, {
        fromDate: fromDate,
        toDate: toDate,
        onComplete: onComplete,
        numberOfMonths: 12,
        maxDays: main_javascripts_constants_HotelConstants__WEBPACK_IMPORTED_MODULE_19__/* .MAX_SEARCH_HOTEL_DAYS */ ._r,
        outOfRangeMessage: t("search.calendarMaxDaysMessage"),
        startDateLabel: t("label:common.checkinDate"),
        endDateLabel: t("label:common.checkoutDate"),
        dateType: pickerDateType
      })
    }) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(main_javascripts_components_molecules_DatePicker_HorizontalDatePicker__WEBPACK_IMPORTED_MODULE_7__/* .HorizontalDatePicker */ .R, {
      fromDate: fromDate,
      toDate: toDate,
      onUpdate: onUpdate,
      hidePicker: hidePicker,
      numberOfMonths: 12,
      maxDays: main_javascripts_constants_HotelConstants__WEBPACK_IMPORTED_MODULE_19__/* .MAX_SEARCH_HOTEL_DAYS */ ._r,
      outOfRangeMessage: t("search.calendarMaxDaysMessage"),
      startDateLabel: t("label:common.checkinDate"),
      endDateLabel: t("label:common.checkoutDate"),
      displayedPicker: displayedPicker,
      dateType: pickerDateType,
      fromInputRef: inputCheckInRef.current,
      toInputRef: inputCheckOutRef.current
    })]
  });
};

var areEqual = function areEqual(prevProps, nextProps) {
  return react_fast_compare__WEBPACK_IMPORTED_MODULE_1___default()(prevProps, nextProps);
};

var HotelDatePickerBlock = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(HotelDatePickerBlockComponent, areEqual);
var blockStyle =  true ? {
  name: "3ldklc",
  styles: "position:relative;flex:1"
} : 0;
var inputBlockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_20__.css)("display:flex;padding:", _styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_9__/* .space.atom */ .D.atom, " 0 0;" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 27114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ CheckinInput; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87536);
/* harmony import */ var main_javascripts_components_form_CalendarDateBlock__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33935);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var CheckinInput = function CheckinInput(props) {
  var namespace = props.namespace,
      isActive = props.isActive,
      onClick = props.onClick,
      labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      inputBlockRef = props.inputBlockRef;
  var fieldName = "checkin_date";

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useFormContext */ .Gc)(),
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors;

  var value = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useWatch */ .qo)({
    control: control,
    name: fieldName
  });
  var attrs = {
    name: fieldName,
    namespace: namespace,
    label: {
      label: "チェックイン",
      colorStyleKey: labelColorStyleKey
    },
    date: value,
    onClick: onClick,
    isActive: isActive,
    error: (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2)(errors, fieldName),
    inputBlockRef: inputBlockRef,
    borderColorStyleKey: borderColorStyleKey
  };
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(main_javascripts_components_form_CalendarDateBlock__WEBPACK_IMPORTED_MODULE_2__/* .CalendarDateBlock */ .A, _objectSpread({}, attrs));
};

/***/ }),

/***/ 82011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ CheckoutInput; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87536);
/* harmony import */ var main_javascripts_components_form_CalendarDateBlock__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33935);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var CheckoutInput = function CheckoutInput(props) {
  var namespace = props.namespace,
      isActive = props.isActive,
      onClick = props.onClick,
      labelColorStyleKey = props.labelColorStyleKey,
      borderColorStyleKey = props.borderColorStyleKey,
      inputBlockRef = props.inputBlockRef;
  var fieldName = "checkout_date";

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useFormContext */ .Gc)(),
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors;

  var value = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useWatch */ .qo)({
    control: control,
    name: fieldName
  });
  var attrs = {
    name: fieldName,
    namespace: namespace,
    label: {
      label: "チェックアウト",
      colorStyleKey: labelColorStyleKey
    },
    date: value,
    onClick: onClick,
    isActive: isActive,
    error: (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2)(errors, fieldName),
    inputBlockRef: inputBlockRef,
    borderColorStyleKey: borderColorStyleKey
  };
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(main_javascripts_components_form_CalendarDateBlock__WEBPACK_IMPORTED_MODULE_2__/* .CalendarDateBlock */ .A, _objectSpread({}, attrs));
};

/***/ }),

/***/ 64400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* reexport */ SocialWebViewSelectionModalDialog; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(10748);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(45959);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/withTranslation.js
var withTranslation = __webpack_require__(91768);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Button/index.ts
var Button = __webpack_require__(84220);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Modal/ModalDialog/ModalDialog.tsx + 1 modules
var ModalDialog = __webpack_require__(14016);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Modal/ModalTitle/index.ts + 2 modules
var ModalTitle = __webpack_require__(80668);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Modal/ModalDescription/index.ts + 2 modules
var ModalDescription = __webpack_require__(73104);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Icon/index.ts
var Icon = __webpack_require__(74303);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Modal/SelectionModalDialog/SelectionModalDialogStyle.ts




var SelectionModalDialogStyle = es/* StyleSheet.create */.mM.create({
  modalButton: {
    maxWidth: "300px",
    margin: "0 auto",
    paddingTop: spaceStyle/* space.atom2x */.D.atom2x
  },
  modalIcon: (0,defineProperty/* default */.Z)({
    display: "block",
    width: "48px",
    height: "48px",
    lineHeight: "48px",
    fontSize: "28px",
    margin: "".concat(spaceStyle/* space.atom */.D.atom, " auto ").concat(spaceStyle/* space.atom1_5x */.D.atom1_5x),
    background: "#ccc",
    color: "#fff",
    borderRadius: "50%",
    textAlign: "center"
  }, (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), {
    margin: "0 auto ".concat(spaceStyle/* space.atom2x */.D.atom2x)
  })
});
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Modal/SelectionModalDialog/SelectionModalDialog.tsx






function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }











var selectionTypeData = {
  hotel: {
    title: "component:modal.selectionTitle",
    description: "component:modal.selectionDescription",
    iconType: "hotel",
    button: "component:search.close"
  },
  hotelEmail: {
    title: "component:modal.selectionTitle",
    description: "component:modal.selectionEmailDescription",
    iconType: "hotel",
    button: "component:search.close"
  },
  hotelCost: {
    title: "component:modal.selectionTitle",
    description: "component:modal.selectionWitCostDescription",
    iconType: "hotel",
    button: "component:search.confirm"
  },
  flight: {
    title: "component:modal.selectionTitle",
    description: "component:modal.selectionEmailDescription",
    iconType: "airplane",
    button: "component:search.close"
  },
  flightEmail: {
    title: "component:modal.selectionTitle",
    description: "component:modal.selectionEmailDescription",
    iconType: "airplane",
    button: "component:search.close"
  },
  flightCost: {
    title: "component:modal.selectionTitle",
    description: "component:modal.selectionWitCostDescription",
    iconType: "airplane",
    button: "component:search.confirm"
  }
};

var SelectionModalDialogComponent = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(SelectionModalDialogComponent, _React$Component);

  var _super = _createSuper(SelectionModalDialogComponent);

  function SelectionModalDialogComponent() {
    (0,classCallCheck/* default */.Z)(this, SelectionModalDialogComponent);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(SelectionModalDialogComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          displayed = _this$props.displayed,
          hasCostMessage = _this$props.hasCostMessage,
          closeHandler = _this$props.closeHandler,
          selectionType = _this$props.selectionType,
          t = _this$props.t;
      var selectionText = hasCostMessage ? selectionTypeData["".concat(selectionType, "Cost")] : selectionTypeData[selectionType];
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ModalDialog/* ModalDialog */.p, {
        displayed: displayed,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
              styleKey: selectionTypeData[selectionType].iconType,
              styles: SelectionModalDialogStyle.modalIcon
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ModalTitle/* ModalTitle */.r, {
              children: t(selectionText.title, {
                type: t("label:common.".concat(selectionType))
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ModalDescription/* ModalDescription */.k, {
              children: t(selectionText.description)
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
            styles: {
              block: SelectionModalDialogStyle.modalButton
            },
            onClick: closeHandler,
            children: t(selectionText.button)
          })]
        })
      });
    }
  }]);

  return SelectionModalDialogComponent;
}(react.Component);

var SelectionModalDialog = (0,withTranslation/* withTranslation */.Z)(["component"])(SelectionModalDialogComponent);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Modal/SelectionModalDialog/index.ts

;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Modal/SocialWebViewSelectionModalDialog/SocialWebViewSelectionModalDialog.tsx










function SocialWebViewSelectionModalDialog_createSuper(Derived) { var hasNativeReflectConstruct = SocialWebViewSelectionModalDialog_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function SocialWebViewSelectionModalDialog_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }




var SocialWebViewSelectionModalDialog = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(SocialWebViewSelectionModalDialog, _React$Component);

  var _super = SocialWebViewSelectionModalDialog_createSuper(SocialWebViewSelectionModalDialog);

  function SocialWebViewSelectionModalDialog() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, SocialWebViewSelectionModalDialog);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "closeHandler", /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _this$props, initializedLIFF, initializedFacebookMessenger, closeHandler;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, initializedLIFF = _this$props.initializedLIFF, initializedFacebookMessenger = _this$props.initializedFacebookMessenger, closeHandler = _this$props.closeHandler;

              try {
                if (initializedLIFF) {
                  liff.closeWindow();
                } else if (initializedFacebookMessenger) {
                  window.MessengerExtensions.requestCloseBrowser();
                }
              } catch (e) {//
              }

              if (closeHandler) {
                closeHandler();
              }

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    return _this;
  }

  (0,createClass/* default */.Z)(SocialWebViewSelectionModalDialog, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          displayed = _this$props2.displayed,
          hasCostMessage = _this$props2.hasCostMessage,
          selectionType = _this$props2.selectionType;
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectionModalDialog, {
        displayed: displayed,
        selectionType: selectionType,
        closeHandler: this.closeHandler,
        hasCostMessage: hasCostMessage
      });
    }
  }]);

  return SocialWebViewSelectionModalDialog;
}(react.Component);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Modal/SocialWebViewSelectionModalDialog/index.ts


/***/ }),

/***/ 5203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ Description; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var main_javascripts_components_atoms_H2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84026);
/* harmony import */ var main_javascripts_components_atoms_Paragraph__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10798);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);





var Description = function Description(props) {
  if (!props.description) {
    return null;
  }

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(main_javascripts_components_atoms_H2__WEBPACK_IMPORTED_MODULE_1__.H2, {
      children: "\u7D39\u4ECB"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(main_javascripts_components_atoms_Paragraph__WEBPACK_IMPORTED_MODULE_2__/* .Paragraph */ .n, {
      children: props.description
    })]
  });
};

/***/ }),

/***/ 78253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* reexport safe */ _Description__WEBPACK_IMPORTED_MODULE_0__.d; }
/* harmony export */ });
/* harmony import */ var _Description__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5203);


/***/ }),

/***/ 78839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ Header; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./main/javascripts/components/molecules/StarRating/StarNumRating/index.ts + 2 modules
var StarNumRating = __webpack_require__(14664);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Paragraph/Paragraph.tsx + 1 modules
var Paragraph = __webpack_require__(20455);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Icon/Icon.tsx
var Icon = __webpack_require__(88740);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/H1/index.ts + 2 modules
var H1 = __webpack_require__(3007);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Spot/Header/HeaderStyle.ts



var HeaderStyle = es/* StyleSheet.create */.mM.create({
  icon: {
    verticalAlign: "middle",
    fontSize: "1.3rem",
    position: "relative",
    left: "-2px",
    color: colorStyle/* textColor.disabledColor */.zP.disabledColor
  },
  address: {
    verticalAlign: "middle"
  },
  addressBlock: {
    padding: spaceStyle/* space.atom */.D.atom
  }
});
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Spot/Header/Header.tsx











var HeaderComponent = function HeaderComponent(props) {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H1.H1, {
      children: props.name
    }), props.rating ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StarNumRating/* StarNumRating */.p, {
      rating: props.rating
    }) : "", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Paragraph/* Paragraph */.n, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
          styleKey: "pin",
          styles: HeaderStyle.icon
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
          className: (0,es/* css */.iv)(HeaderStyle.address),
          children: props.address
        })]
      })
    })]
  });
};

var Header = /*#__PURE__*/react.memo(HeaderComponent);

/***/ }),

/***/ 20825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* reexport safe */ _Header__WEBPACK_IMPORTED_MODULE_0__.h; }
/* harmony export */ });
/* harmony import */ var _Header__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78839);


/***/ }),

/***/ 43575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ ReviewListStyle; }
/* harmony export */ });
/* harmony import */ var aphrodite__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34397);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36716);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80910);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96749);




var ReviewListStyle = aphrodite__WEBPACK_IMPORTED_MODULE_0__/* .StyleSheet.create */ .mM.create({
  header: {
    display: "flex",
    alignItems: "center"
  },
  author: {
    verticalAlign: "middle"
  },
  headline: {
    fontSize: main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.mediumHeading */ .JB.mediumHeading,
    color: main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .accentColor.primaryColor */ .z.primaryColor,
    fontWeight: main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight.bold */ .Ue.bold,
    textAlign: "center",
    letterSpacing: "0.2em"
  },
  authorBlock: {
    fontSize: main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.caption */ .JB.caption,
    lineHeight: "1",
    color: main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_2__/* .textColor.secondaryDarkColor */ .zP.secondaryDarkColor
  },
  ratingBlock: {
    fontSize: main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.title */ .JB.title,
    textAlign: "center",
    paddingBottom: main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_3__/* .space.atom2x */ .D.atom2x
  },
  starBlock: {
    fontSize: main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.title */ .JB.title
  },
  starNum: {
    fontSize: main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.mediumHeading */ .JB.mediumHeading
  },
  review: {
    paddingTop: 0
  }
});

/***/ }),

/***/ 14664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* reexport */ StarNumRating; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/StarRating/StarNumRating/StarNumRatingStyle.ts




var StarNumRatingStyle = es/* StyleSheet.create */.mM.create({
  block: {
    position: "relative",
    fontSize: typographyStyle/* fontSize.body */.JB.body,
    padding: spaceStyle/* space.atom */.D.atom
  },
  starBlock: {
    position: "relative",
    padding: 0,
    display: "inline-block",
    verticalAlign: "middle"
  },
  num: {
    fontSize: typographyStyle/* fontSize.caption */.JB.caption,
    lineHeight: typographyStyle/* lineHeight.noSpace */.Nv.noSpace,
    color: colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor,
    display: "inline-block",
    verticalAlign: "middle",
    padding: "0 0 0 ".concat(spaceStyle/* space.atom0_5x */.D.atom0_5x),
    letterSpacing: "0.05em"
  }
});
// EXTERNAL MODULE: ./main/javascripts/components/atoms/StarRating/index.ts + 2 modules
var StarRating = __webpack_require__(18339);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/StarRating/StarNumRating/StarNumRating.tsx


var _excluded = ["rating", "styles"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var StarNumRating = function StarNumRating(props) {
  var rating = props.rating,
      _props$styles = props.styles,
      styles = _props$styles === void 0 ? {} : _props$styles,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  var block = styles.block,
      starBlock = styles.starBlock,
      num = styles.num;

  if (rating === 0) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", _objectSpread(_objectSpread({
    className: (0,es/* css */.iv)(StarNumRatingStyle.block, block)
  }, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StarRating/* StarRating */.Z, {
      rating: rating,
      styles: {
        block: [StarNumRatingStyle.starBlock, starBlock]
      }
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      className: (0,es/* css */.iv)(StarNumRatingStyle.num, num),
      children: rating
    })]
  }));
};
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/StarRating/StarNumRating/index.ts


/***/ }),

/***/ 42842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* reexport */ HotelHead; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/withTranslation.js
var withTranslation = __webpack_require__(91768);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./main/javascripts/components/head/MainHead.tsx + 2 modules
var MainHead = __webpack_require__(65025);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/organisms/Hotel/HotelHead/HotelHead.tsx


var _excluded = ["hotelName", "t"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







function HotelHeadComponent(props) {
  var hotelName = props.hotelName,
      t = props.t,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  var router = (0,next_router.useRouter)();
  var pathname = router.pathname;
  var title;
  var description;

  if (pathname === "/hotels/[hotelId]" && hotelName) {
    title = t("seo.titleHotelShow", {
      name: hotelName
    });
    description = t("seo.descriptionHotelShow", {
      name: hotelName
    });
  } else {
    title = t("seo.titleHotelIndex");
    description = t("seo.descriptionHotelIndex");
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MainHead/* MainHead */.I, _objectSpread({
    title: title,
    description: description
  }, rest));
}

var HotelHead = (0,withTranslation/* withTranslation */.Z)(["constant"])(HotelHeadComponent);
;// CONCATENATED MODULE: ./main/javascripts/components/organisms/Hotel/HotelHead/index.ts


/***/ }),

/***/ 30522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ useUserAccount; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95094);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _sentry_node__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39666);
/* harmony import */ var main_javascripts_slices_accountParamSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12297);
/* harmony import */ var main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25968);
/* harmony import */ var main_javascripts_slices_currentUserSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94265);






 // useAccountのredux toolkit版
// liff.initをここですると、同一ページでLiffTypesが違うところから来ると不整合が出るのでしない。必要なところでinitする

var useUserAccount = function useUserAccount(store) {
  var enableSocialSignedInCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();

  var loadAccount = function loadAccount() {
    return store.dispatch((0,main_javascripts_slices_accountParamSlice__WEBPACK_IMPORTED_MODULE_2__/* .fetchAccountParams */ .Nv)({
      param: ""
    })).then(_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .unwrapResult */ .SI).then(function (result) {
      var accountParams = result;

      if (accountParams) {
        // 取得したデータを各reducerで直接保存しているため
        // 以前のinitCurrentUser/initAccountParamsは不要
        if (enableSocialSignedInCheck) {
          checkInitializedSocial(accountParams.facebookAppId);
        }
      }
    });
  };

  var checkLIFFState = function checkLIFFState() {
    try {
      var _liff;

      var context = (_liff = liff) === null || _liff === void 0 ? void 0 : _liff.getOS();

      if (context) {
        store.dispatch((0,main_javascripts_slices_currentUserSlice__WEBPACK_IMPORTED_MODULE_4__/* .setIsLIFFInitialized */ .hV)(true));
      }

      if (liff.id && liff.isLoggedIn()) {
        store.dispatch((0,main_javascripts_slices_currentUserSlice__WEBPACK_IMPORTED_MODULE_4__/* .setIsLIFFLoggedIn */ .ux)(true));
      }
    } catch (_unused) {// do nothing
    }
  };

  var onLoadScriptLIFF = function onLoadScriptLIFF() {
    checkLIFFState();
  };

  var loadScript = function loadScript(url, onload) {
    var script = document.createElement("script");
    script.src = url;
    script.async = true;
    script.onload = onload ? onload : null;
    document.body.appendChild(script);
  };

  var checkInitializedSocial = function checkInitializedSocial(facebookAppId) {
    if (typeof liff !== "undefined") {
      checkLIFFState();
    } else {
      loadScript(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_3__/* .LINE_LIFF_SDK_URL */ .i3, onLoadScriptLIFF);
    } // FacebookMessengerは現在使用していない


    if (facebookAppId) {//   (window as any).MessengerExtensions?.getContext(
      //     facebookAppId,
      //     (): void => {
      //       store.dispatch(setIsFacebookMessengerInitialized(true));
      //     },
      //     (err: any): void => {
      //       console.log("FBM ERROR ", err);
      //     }
      //   );
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (router.isReady) {
      loadAccount()["catch"](function (e) {
        console.error(e);

        if (true) {
          _sentry_node__WEBPACK_IMPORTED_MODULE_6__/* .captureException */ .Tb(e.errorMessages || e);
        }
      });
    }
  }, [router.isReady]);
  return;
};

/***/ }),

/***/ 64949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ ImageSchema; }
/* harmony export */ });
/* harmony import */ var normalizr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82677);

var ImageSchema = new normalizr__WEBPACK_IMPORTED_MODULE_0__/* .schema.Entity */ .fK.Entity("image", {}, {
  idAttribute: "url"
});

/***/ }),

/***/ 63453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ getResearchFlightLiffId; },
/* harmony export */   "LG": function() { return /* binding */ getResearchHotelLiffId; },
/* harmony export */   "ns": function() { return /* binding */ getAvailableFacebookMessengerRegisterUrl; }
/* harmony export */ });
/* unused harmony exports getAvailableLineRegisterUrl, getIsFetchedAccountParam */
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22222);
/* harmony import */ var _LocaleSelector__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75285);



var getUtmSource = function getUtmSource(state) {
  return state.accountParamsReducer.utmSource;
};

var getLineRegisterUrl = function getLineRegisterUrl(state) {
  return state.accountParamsReducer.lineRegisterUrl;
};

var getAvailableLineRegisterUrl = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(getUtmSource, getLineRegisterUrl, _LocaleSelector__WEBPACK_IMPORTED_MODULE_1__/* .getLocale */ .K, function (utmSource, lineRegisterUrl, locale) {
  // 日本以外サポート外
  if (locale !== "ja") {
    return null;
  }

  if ((utmSource === "line" || !utmSource) && lineRegisterUrl) {
    return lineRegisterUrl;
  }

  return null;
});
var getAvailableFacebookMessengerRegisterUrl = (0,reselect__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(getUtmSource, function (utmSource) {
  if (utmSource === "facebook") {
    return "https://m.me/tabitabi.official";
  }

  return null;
});
var getResearchFlightLiffId = function getResearchFlightLiffId(state) {
  return state.accountParamsReducer.researchFlightLiffId;
};
var getIsFetchedAccountParam = function getIsFetchedAccountParam(state) {
  return state.accountParamsReducer.isFetchedAccountParam;
};
var getResearchHotelLiffId = function getResearchHotelLiffId(state) {
  return state.accountParamsReducer.researchHotelLiffId;
};

/***/ }),

/***/ 75285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ getLocale; }
/* harmony export */ });
var getLocale = function getLocale(state) {
  return state.localeReducer.locale;
};

/***/ }),

/***/ 92494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ loadVConsole; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50029);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);


var loadVConsole = /*#__PURE__*/function () {
  var _ref = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(maxLog) {
    var forceEnable,
        VConsole,
        _args = arguments;
    return _frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            forceEnable = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;

            if (!( false || forceEnable)) {
              _context.next = 6;
              break;
            }

            _context.next = 4;
            return __webpack_require__.e(/* import() */ 7503).then(__webpack_require__.t.bind(__webpack_require__, 71415, 23));

          case 4:
            VConsole = _context.sent["default"];
            new VConsole({
              disableLogScrolling: false,
              maxLogNumber: maxLog
            });

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function loadVConsole(_x) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ 63591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XR": function() { return /* binding */ sanitizePassportNameInput; },
/* harmony export */   "dR": function() { return /* binding */ formatAndConvertServerErrorToForm; },
/* harmony export */   "fz": function() { return /* binding */ convertServerErrorToForm; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56264);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(humps__WEBPACK_IMPORTED_MODULE_0__);


var convertServerErrorToForm = function convertServerErrorToForm(serverErrors, setErrorFn) {
  if (serverErrors !== null && serverErrors !== void 0 && serverErrors.messages) {
    setErrorFn("form", {
      type: "server",
      message: serverErrors.messages.join("\n")
    });
  }

  if (serverErrors !== null && serverErrors !== void 0 && serverErrors.fieldMessages) {
    serverErrors.fieldMessages.map(function (fieldError) {
      var parseField = function parseField(error) {
        var parentKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        var key = (0,humps__WEBPACK_IMPORTED_MODULE_0__.decamelize)(Object.keys(error)[0]);

        if (parentKey) {
          key = "".concat(parentKey, ".").concat(key);
        }

        var value = Object.values(error)[0];

        if (Array.isArray(value) && typeof value[0] === "object") {
          value.map(function (subValue) {
            parseField(subValue, key);
            return null;
          });
        } else {
          setErrorFn(key, {
            type: "server",
            message: value.join("\n")
          });
        }
      };

      parseField(fieldError);
    });
  }
};
var formatAndConvertServerErrorToForm = function formatAndConvertServerErrorToForm(errorResponse, setErrorFn) {
  // エラー形式を合わせるために変換している
  if (Array.isArray(errorResponse.errors)) {
    var errorMessages = errorResponse.errorMessages;
    convertServerErrorToForm({
      messages: errorMessages
    }, setErrorFn);
  } else {
    var errors = Object.keys(errorResponse.errors).map(function (key) {
      if (key === "base") {
        // サーバーからbaseで返された場合はformに変換
        return {
          form: errorResponse.errors[key]
        };
      }

      return (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, key, errorResponse.errors[key]);
    });
    convertServerErrorToForm({
      fieldMessages: errors
    }, setErrorFn);
  }
};
var sanitizePassportNameInput = function sanitizePassportNameInput(value) {
  return value ? value.trim().toUpperCase() : "";
};

/***/ }),

/***/ 66479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cg": function() { return /* binding */ convertHotelReservationFormValuesToParams; },
/* harmony export */   "Dx": function() { return /* binding */ updateHotelIndexUrl; },
/* harmony export */   "EJ": function() { return /* binding */ updateHotelShowUrl; },
/* harmony export */   "PO": function() { return /* binding */ preparePollHotelsParam; },
/* harmony export */   "rz": function() { return /* binding */ getHotelGradeText; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ObjectUtil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76614);
/* harmony import */ var _FormUtil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63591);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




function preparePollHotelsParam(param) {
  var submitParam = _objectSpread({}, param);

  if (submitParam.min_price && typeof submitParam.min_price === "string") {
    delete submitParam.min_price;
  }

  if (submitParam.max_price && typeof submitParam.max_price === "string" || submitParam.max_price === 0) {
    delete submitParam.max_price;
  }

  if (!submitParam.min_rank || parseInt(submitParam.min_rank, 10) === 0) {
    delete submitParam.min_rank;
  }

  if (!submitParam.min_rating || parseInt(submitParam.min_rating, 10) === 0) {
    delete submitParam.min_rating;
  }

  if (!submitParam.bed_count || parseInt(submitParam.bed_count, 10) === 0) {
    delete submitParam.bed_count;
  }

  if (!submitParam.meal_type) {
    delete submitParam.meal_type;
  }

  if (!submitParam.view_type) {
    delete submitParam.view_type;
  }

  if (!submitParam.bed_types) {
    delete submitParam.bed_types;
  }

  if (!submitParam.rank) {
    delete submitParam.rank;
  }

  if (!submitParam.descending_region_ids) {
    delete submitParam.descending_region_ids;
  }

  if (!submitParam.sort_by) {
    delete submitParam.sort_by;
  }

  return submitParam;
}
function updateHotelIndexUrl(param, router) {
  var newUrl = "/hotels?".concat((0,qs__WEBPACK_IMPORTED_MODULE_1__.stringify)(param, {
    arrayFormat: "indices"
  }));

  if (location.hash) {
    newUrl += location.hash; // lineなどがaccessTokenなどをくっつけてるため
  } // shallow: trueにしないと再度サーバーサイドの処理が動作してしまうため注意


  router.replace(newUrl, null, {
    shallow: true
  });
}
function updateHotelShowUrl(param, router) {
  var newUrl = "".concat(location.pathname, "?").concat((0,qs__WEBPACK_IMPORTED_MODULE_1__.stringify)(param, {
    arrayFormat: "indices"
  }));

  if (location.hash) {
    newUrl += location.hash; // lineなどがaccessTokenなどをくっつけてるため
  } // shallow: trueにしないと再度サーバーサイドの処理が動作してしまうため注意


  router.replace(newUrl, null, {
    shallow: true
  });
}
function getHotelGradeText(grade, t) {
  if (grade > 0 && grade <= 5) {
    return t("unit:grade".concat(Math.ceil(grade)));
  }

  return "";
}
var convertHotelReservationFormValuesToParams = function convertHotelReservationFormValuesToParams(data) {
  var _params$guests;

  var params = (0,_ObjectUtil__WEBPACK_IMPORTED_MODULE_3__/* .clone */ .d9)(data);

  if (((_params$guests = params.guests) === null || _params$guests === void 0 ? void 0 : _params$guests.length) > 0) {
    params.guests = params.guests.map(function (guest) {
      var newGuest = _objectSpread({}, guest);

      newGuest.first_name = (0,_FormUtil__WEBPACK_IMPORTED_MODULE_2__/* .sanitizePassportNameInput */ .XR)(newGuest.first_name);
      newGuest.last_name = (0,_FormUtil__WEBPACK_IMPORTED_MODULE_2__/* .sanitizePassportNameInput */ .XR)(newGuest.last_name);
      return newGuest;
    });
  }

  return params;
};

/***/ }),

/***/ 96786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _hotelId_; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/I18nextProvider.js
var I18nextProvider = __webpack_require__(6339);
// EXTERNAL MODULE: ./node_modules/humps/humps.js
var humps = __webpack_require__(56264);
// EXTERNAL MODULE: ./main/javascripts/store.ts + 1 modules
var store = __webpack_require__(79169);
// EXTERNAL MODULE: ./main/javascripts/containers/organisms/Header/HeaderContainer.ts
var HeaderContainer = __webpack_require__(12664);
// EXTERNAL MODULE: ./main/javascripts/styles/globalStyle.ts
var globalStyle = __webpack_require__(15305);
// EXTERNAL MODULE: ./i18n.ts + 313 modules
var i18n = __webpack_require__(44349);
// EXTERNAL MODULE: ./main/javascripts/components/organisms/Hotel/HotelHead/index.ts + 1 modules
var HotelHead = __webpack_require__(42842);
// EXTERNAL MODULE: ./main/javascripts/hooks/common/useConstructor.ts
var useConstructor = __webpack_require__(83795);
// EXTERNAL MODULE: ./main/javascripts/features/hotel/hotelSlice.ts
var hotelSlice = __webpack_require__(74659);
// EXTERNAL MODULE: ./main/javascripts/actions/Constants.ts
var Constants = __webpack_require__(9933);
// EXTERNAL MODULE: ./main/javascripts/hooks/common/useUserAccount.tsx
var useUserAccount = __webpack_require__(30522);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(95094);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-fast-compare/index.js
var react_fast_compare = __webpack_require__(69590);
var react_fast_compare_default = /*#__PURE__*/__webpack_require__.n(react_fast_compare);
// EXTERNAL MODULE: ./main/javascripts/components/spot/ImageList.tsx
var ImageList = __webpack_require__(43872);
// EXTERNAL MODULE: ./main/javascripts/components/molecules/Spot/Header/index.ts
var Header = __webpack_require__(20825);
// EXTERNAL MODULE: ./main/javascripts/components/molecules/Spot/Description/index.ts
var Description = __webpack_require__(78253);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/GoogleMap/index.ts + 2 modules
var GoogleMap = __webpack_require__(99374);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/spot/Location.tsx









var Location = function Location(props) {
  var latitude = props.latitude,
      longitude = props.longitude;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["component"]),
      t = _useTranslation.t; // const encodedAddress = encodeURI(address);
  // const encodedName = encodeURI(name);
  // const googleMapUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}+${encodedName}`;
  // 緯度経度で指定する場合


  var googleMapUrl = "https://www.google.com/maps/search/?api=1&query=".concat(latitude, ",").concat(longitude);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GoogleMap/* GoogleMap */.b, {
      latitude: latitude,
      longitude: longitude
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        css: linkStyle,
        href: googleMapUrl,
        target: "_blank",
        rel: "nofollow noreferrer",
        children: t("common.viewLargerMap")
      })
    })]
  });
};
var linkStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom0_5x */.D.atom0_5x, ";margin:", spaceStyle/* space.atom0_5x */.D.atom0_5x, ";font-size:", typographyStyle/* fontSize.body */.JB.body, ";line-height:", typographyStyle/* lineHeight.body2 */.Nv.body2, ";color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";text-decoration:none;border-bottom:1px solid;transition:color 0.3s ease;&:hover{color:", colorStyle/* accentColor.primaryDarkColor */.z.primaryDarkColor, ";}" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/H2/index.ts + 2 modules
var H2 = __webpack_require__(84026);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/HorizontalRule/index.ts + 2 modules
var HorizontalRule = __webpack_require__(28075);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Paragraph/index.ts
var Paragraph = __webpack_require__(10798);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/StarRating/index.ts + 2 modules
var StarRating = __webpack_require__(18339);
// EXTERNAL MODULE: ./main/javascripts/components/molecules/Spot/ReviewList/ReviewListStyle.ts
var ReviewListStyle = __webpack_require__(43575);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var aphrodite_es = __webpack_require__(34397);
// EXTERNAL MODULE: ./main/javascripts/components/molecules/StarRating/StarNumRating/index.ts + 2 modules
var StarNumRating = __webpack_require__(14664);
;// CONCATENATED MODULE: ./main/javascripts/utils/googleReviewUtil.ts
var defaultGoogleReview = {
  rating: 0,
  author_name: "",
  text: "",
  authorUrl: "",
  time: 0
};
var googleReviewMaxRating = function googleReviewMaxRating() {
  return 5;
};
var getGoogleReviewFormattedTime = function getGoogleReviewFormattedTime(review) {
  // clientとseverでずれるのでutcで統一
  var date = new Date(review.time * 1000);
  date.setTime(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
  var month = "0".concat(date.getMonth() + 1).slice(-2);
  var day = "0".concat(date.getDate()).slice(-2);
  return "".concat(date.getFullYear(), "/").concat(month, "/").concat(day);
};
;// CONCATENATED MODULE: ./main/javascripts/components/spot/ReviewList.tsx













// TODO: aphroditeと旧コンポーネント使用中
var ReviewListComponent = function ReviewListComponent(props) {
  var reviews = props.reviews,
      rating = props.rating;

  var renderTotalRating = function renderTotalRating() {
    if (!rating) {
      return null;
    }

    var ratingStyles = {
      block: ReviewListStyle/* ReviewListStyle.ratingBlock */.Q.ratingBlock,
      starBlock: ReviewListStyle/* ReviewListStyle.starBlock */.Q.starBlock,
      num: ReviewListStyle/* ReviewListStyle.starNum */.Q.starNum
    };
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StarNumRating/* StarNumRating */.p, {
      rating: rating,
      styles: ratingStyles
    });
  };

  var renderReviewList = function renderReviewList() {
    var reviewLength = reviews.length;
    return reviews.map(function (review, index) {
      // const ratingPercentage: number = review.rating / 5 * 100;
      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          className: (0,aphrodite_es/* css */.iv)(ReviewListStyle/* ReviewListStyle.header */.Q.header),
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StarRating/* StarRating */.Z, {
            rating: review.rating
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              className: (0,aphrodite_es/* css */.iv)(ReviewListStyle/* ReviewListStyle.authorBlock */.Q.authorBlock),
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: review.author_name
              }), " ", (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                children: ["(", getGoogleReviewFormattedTime(review), ")"]
              })]
            })
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Paragraph/* Paragraph */.n, {
          styles: ReviewListStyle/* ReviewListStyle.review */.Q.review,
          children: review.text
        }), index + 1 === reviewLength ? "" : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalRule/* HorizontalRule */.b, {})]
      }, index);
    });
  };

  if (reviews.length === 0) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H2.H2, {
      styles: ReviewListStyle/* ReviewListStyle.headline */.Q.headline,
      children: "\u30EC\u30D3\u30E5\u30FC"
    }), renderTotalRating(), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      children: renderReviewList()
    })]
  });
};

var areEqual = function areEqual(prevProps, nextProps) {
  return react_fast_compare_default()(prevProps, nextProps);
};

var ReviewList = /*#__PURE__*/react.memo(ReviewListComponent, areEqual);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Block/BasicBlock/index.ts
var BasicBlock = __webpack_require__(98034);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Block/MainBlock/index.ts
var MainBlock = __webpack_require__(59941);
;// CONCATENATED MODULE: ./main/javascripts/components/organisms/Hotel/Show/MainStyle.ts



var MainStyle = aphrodite_es/* StyleSheet.create */.mM.create({
  block: {
    paddingTop: 0,
    cursor: "pointer"
  },
  imageListBlock: {
    padding: "0 0 ".concat(spaceStyle/* space.atom */.D.atom)
  },
  basicInfoBlock: {
    padding: "".concat(spaceStyle/* space.atom */.D.atom)
  },
  reviewListBlock: {
    padding: "0 ".concat(spaceStyle/* space.atom */.D.atom, " ").concat(spaceStyle/* space.atom3x */.D.atom3x, " ").concat(spaceStyle/* space.atom */.D.atom),
    ":before": {
      content: "''",
      display: "block",
      borderTop: "1px solid ".concat(colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor),
      margin: "0 ".concat(spaceStyle/* space.atom */.D.atom, " ").concat(spaceStyle/* space.atom3x */.D.atom3x)
    }
  },
  stepIndicatorBlock: {
    paddingBottom: spaceStyle/* space.atom3x */.D.atom3x
  }
});
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./main/javascripts/components/card/Card.tsx
var Card = __webpack_require__(99615);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Card/CardTitle.tsx
var CardTitle = __webpack_require__(27318);
// EXTERNAL MODULE: ./main/javascripts/api/AxiosWrapper.ts
var AxiosWrapper = __webpack_require__(46208);
;// CONCATENATED MODULE: ./main/javascripts/api/HotelPreReservationApi.ts



function fetchHotelPreReservation(_x) {
  return _fetchHotelPreReservation.apply(this, arguments);
}

function _fetchHotelPreReservation() {
  _fetchHotelPreReservation = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(param) {
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", (0,AxiosWrapper/* createWrapper */.K)().post("/api/hotel_pre_reservations.json", {
              hotel_pre_reservation: param
            }).then( /*#__PURE__*/function () {
              var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(response) {
                return regenerator_default().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        return _context.abrupt("return", Promise.resolve({
                          data: response.data
                        }));

                      case 1:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x2) {
                return _ref.apply(this, arguments);
              };
            }())["catch"]( /*#__PURE__*/function () {
              var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(error) {
                return regenerator_default().wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        return _context2.abrupt("return", Promise.reject({
                          errors: error.response.data.errors
                        }));

                      case 1:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function (_x3) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _fetchHotelPreReservation.apply(this, arguments);
}
// EXTERNAL MODULE: ./main/javascripts/api/DynamicPackagePreReservationApi.ts
var DynamicPackagePreReservationApi = __webpack_require__(42831);
// EXTERNAL MODULE: ./main/javascripts/components/button/ButtonWithLoader.tsx + 1 modules
var ButtonWithLoader = __webpack_require__(51185);
// EXTERNAL MODULE: ./main/javascripts/constants/SocialMediaTypes.ts
var SocialMediaTypes = __webpack_require__(22884);
// EXTERNAL MODULE: ./main/javascripts/api/LiffApi.ts
var LiffApi = __webpack_require__(86133);
;// CONCATENATED MODULE: ./main/javascripts/api/SelectHotelApi.ts



function postSelectHotel(_x) {
  return _postSelectHotel.apply(this, arguments);
}

function _postSelectHotel() {
  _postSelectHotel = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(param) {
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", (0,AxiosWrapper/* createWrapper */.K)().post("/api/select_hotels.json", param).then( /*#__PURE__*/function () {
              var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(response) {
                return regenerator_default().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        return _context.abrupt("return", Promise.resolve({
                          data: response.data
                        }));

                      case 1:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x2) {
                return _ref.apply(this, arguments);
              };
            }())["catch"]( /*#__PURE__*/function () {
              var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(error) {
                return regenerator_default().wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        return _context2.abrupt("return", Promise.reject({
                          errors: error.response.data.errors,
                          errorCode: error.response.data.error_code,
                          errorMessages: error.response.data.error_messages
                        }));

                      case 1:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function (_x3) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _postSelectHotel.apply(this, arguments);
}
// EXTERNAL MODULE: ./main/javascripts/constants/SearchTypes.ts
var SearchTypes = __webpack_require__(67032);
// EXTERNAL MODULE: ./main/javascripts/utils/ScrollUtil.ts
var ScrollUtil = __webpack_require__(75215);
// EXTERNAL MODULE: ./main/javascripts/selectors/AccountParamsSelector.ts
var AccountParamsSelector = __webpack_require__(63453);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
// EXTERNAL MODULE: ./main/javascripts/constants/PlatformTypes.ts
var PlatformTypes = __webpack_require__(40692);
// EXTERNAL MODULE: ./main/javascripts/utils/googleTagManagerUtil.ts
var googleTagManagerUtil = __webpack_require__(49224);
// EXTERNAL MODULE: ./main/javascripts/slices/currentUserSlice.ts
var currentUserSlice = __webpack_require__(94265);
;// CONCATENATED MODULE: ./main/javascripts/features/hotel/components/hotelRoom/HotelPlanContent.tsx



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











 // import { beginShareFlowToCurrentThread } from "main/javascripts/api/FacebookMessengerApi";
















var HotelPlanContent = function HotelPlanContent(props) {
  var hotelId = props.hotelId,
      hotelRoomId = props.hotelRoomId,
      hotelPlan = props.hotelPlan,
      param = props.param,
      onSelectHotelPlan = props.onSelectHotelPlan,
      loggedInSocialMedia = props.loggedInSocialMedia;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["label"]),
      t = _useTranslation.t;

  var researchHotelLiffId = (0,store/* useAppSelector */.CG)(AccountParamsSelector/* getResearchHotelLiffId */.LG);
  var currentUser = (0,store/* useAppSelector */.CG)(currentUserSlice/* currentUserSelector */.ib);
  var showRoomNumCount = 5;
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(false),
      isSubmitting = _useState[0],
      setIsSubmitting = _useState[1];

  var _useState2 = (0,react.useState)(""),
      errorText = _useState2[0],
      setErrorText = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      hasCostMessage = _useState3[0],
      setHasCostMessage = _useState3[1];

  var onSelect = function onSelect() {
    if (onSelectHotelPlan) {
      onSelectHotelPlan(hasCostMessage);
    }
  };

  var onSelectError = function onSelectError(err) {
    setErrorText(String(err));
  };

  var onClickSelection = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _yield$postSelectHote, data;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsSubmitting(true);
              setErrorText("");
              setHasCostMessage(false);
              _context.prev = 3;
              _context.next = 6;
              return postSelectHotel({
                room_id: hotelRoomId,
                plan_id: hotelPlan.id,
                room_cache_id: param.roomCacheId,
                cache_id: param.cacheId,
                l_id: param.lId,
                q_c_id: param.qCId
              });

            case 6:
              _yield$postSelectHote = _context.sent;
              data = _yield$postSelectHote.data;

              // 外部ブラウザでもLIFF.initできるので先にメールユーザーをチェックする
              if ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.chatPlatformType) === PlatformTypes/* PlatformTypes.email */.A.email) {
                onSelect();
                setHasCostMessage(true);
              } else if (loggedInSocialMedia === SocialMediaTypes/* SocialMediaTypes.liff */.k.liff) {
                if (data.messageText && data.messageText.length > 1) {
                  setHasCostMessage(true);
                }

                (0,LiffApi/* sendLiffTextMessages */.N)(data.messageText, researchHotelLiffId, onSelect, onSelectError);
              } else if (loggedInSocialMedia === SocialMediaTypes/* SocialMediaTypes.facebookMessenger */.k.facebookMessenger) {// 現在FB未使用
                // const element: any = [
                //   {
                //     title: data.messageText[0],
                //     buttons: [
                //       {
                //         type: "web_url",
                //         url: "https://tabi-two.com/",
                //         title: "hotel information",
                //       },
                //     ],
                //   },
                // ];
                // TODO: beginShareFlowが使えなくなったため、ユーザーにメッセージを送信できない
                // TODO: メッセージ送信方法を別途検討必要
                // beginShareFlowToCurrentThread(element, this.onSelect, this.onSelectError);
                // onSelect();
              }

              setIsSubmitting(false);
              _context.next = 17;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](3);
              console.log(_context.t0);
              setIsSubmitting(false);
              setErrorText(_context.t0.errorMessages);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 12]]);
    }));

    return function onClickSelection() {
      return _ref.apply(this, arguments);
    };
  }();

  var onClickPreReservation = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var _ref3, data, _yield$getDynamicPack, nextData;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setIsSubmitting(true);
              setErrorText("");
              _context2.prev = 2;

              if (!(param.searchType === SearchTypes/* SearchTypes.dynamicPackage */.a.dynamicPackage)) {
                _context2.next = 9;
                break;
              }

              _context2.next = 6;
              return (0,DynamicPackagePreReservationApi/* putDynamicPackagePreReservation */.H$)(param.dynamicPackagePreReservationId, {
                hotel_pre_reservations: [{
                  hotel_id: hotelId,
                  room_id: hotelRoomId,
                  plan_id: hotelPlan.id,
                  room_cache_id: param.roomCacheId,
                  cache_id: param.cacheId,
                  dynamic_package_id: param.dynamicPackageId,
                  search_group_id: param.searchGroupId
                }]
              });

            case 6:
              _context2.t0 = _context2.sent;
              _context2.next = 12;
              break;

            case 9:
              _context2.next = 11;
              return fetchHotelPreReservation({
                hotel_id: hotelId,
                room_id: hotelRoomId,
                plan_id: hotelPlan.id,
                room_cache_id: param.roomCacheId,
                cache_id: param.cacheId,
                dynamic_package_id: param.dynamicPackageId,
                search_group_id: param.searchGroupId
              });

            case 11:
              _context2.t0 = _context2.sent;

            case 12:
              _ref3 = _context2.t0;
              data = _ref3.data;

              if (!param.dynamicPackageId) {
                _context2.next = 22;
                break;
              }

              _context2.next = 17;
              return (0,DynamicPackagePreReservationApi/* getDynamicPackageNextPage */.lR)(param.dynamicPackageId, param.searchGroupId);

            case 17:
              _yield$getDynamicPack = _context2.sent;
              nextData = _yield$getDynamicPack.nextData;

              if (Object.keys(nextData).length === 0) {
                (0,googleTagManagerUtil/* dpPreReservationEvent */.QP)();
                router.push("/dynamic_package_reservations/new?dynamic_package_id=".concat(param.dynamicPackageId, "&cache_id=").concat(data.cacheId));
              } else {
                router.push("/hotels/?".concat((0,lib.stringify)((0,humps.decamelizeKeys)(nextData.conditions), {
                  arrayFormat: "indices"
                }), "\n&cache_id=").concat(nextData.cacheId, "\n&dynamic_package_id=").concat(nextData.dynamicPackageId, "&search_group_id=").concat(nextData.searchGroupId, "&search_type=dp"));
              }

              _context2.next = 23;
              break;

            case 22:
              router.push("/hotel_reservations/new?cache_id=".concat(data.cacheId, "&hotel_id=").concat(hotelId, "&room_cache_id=").concat(param.roomCacheId));

            case 23:
              (0,ScrollUtil/* stopBodyScrolling */.wV)(false);
              _context2.next = 31;
              break;

            case 26:
              _context2.prev = 26;
              _context2.t1 = _context2["catch"](2);
              console.log(_context2.t1);
              setIsSubmitting(false);
              setErrorText(_context2.t1.errorMessages);

            case 31:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 26]]);
    }));

    return function onClickPreReservation() {
      return _ref2.apply(this, arguments);
    };
  }();

  var renderOption = function renderOption() {
    if (hotelPlan.isRefundable || hotelPlan.availableRoomNum > 0 && hotelPlan.availableRoomNum < showRoomNumCount) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: optionBlockStyle,
        children: [hotelPlan.availableRoomNum < showRoomNumCount ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
          css: roomsLeftStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            children: t("common.roomsLeft", {
              count: hotelPlan.availableRoomNum
            })
          })
        }) : "", hotelPlan.isRefundable ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
          css: optionStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            children: t("common.cancelFree")
          })
        }) : ""]
      });
    }

    return null;
  };

  var renderAmenities = function renderAmenities() {
    return hotelPlan.hotelPlanAmenities.map(function (amenity, index) {
      return renderAmenity(amenity, index);
    });
  };

  var renderAmenity = function renderAmenity(amenity, index) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      children: amenity.name
    }, index);
  };

  var renderPrice = function renderPrice() {
    if (param.hotelPlanId || param.lId) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
        css: priceStyle,
        children: hotelPlan.totalPriceDifference
      });
    } else {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
        css: priceStyle,
        children: hotelPlan.inclusiveTotalPrice
      });
    }
  };

  var renderButton = function renderButton() {
    if (param.lId) {
      if (loggedInSocialMedia || currentUser && currentUser.chatPlatformType === PlatformTypes/* PlatformTypes.email */.A.email) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWithLoader/* ButtonWithLoader */.O, {
            type: "submit",
            buttonType: "buttonSmall",
            styles: {
              exBlockStyle: reserveBtnBlockStyle
            },
            onClick: onClickSelection,
            isLoading: isSubmitting,
            children: t("common.select")
          }), errorText && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: errorTextStyle,
            children: errorText
          })]
        });
      } else {
        return null;
      }
    } else {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWithLoader/* ButtonWithLoader */.O, {
        type: "submit",
        buttonType: "buttonSmall",
        styles: {
          exBlockStyle: reserveBtnBlockStyle
        },
        onClick: onClickPreReservation,
        isLoading: isSubmitting,
        children: t("common.select")
      });
    }
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: planItemStyle,
    children: [renderOption(), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: reserveBlockStyle,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: amenityBlockStyle,
        children: renderAmenities()
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: priceBlockStyle,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: priceBlockInnerStyle,
          children: [hotelPlan.hasExtraFee && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: noteTextStyle,
            children: t("component:hotelIndex.extraFeeNotice")
          }), renderPrice(), renderButton()]
        })
      })]
    })]
  });
};
var planItemStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("border-top:1px solid ", colorStyle/* borderColor.primaryLightColor */.tv.primaryLightColor, ";padding:", spaceStyle/* space.atom */.D.atom, ";&:first-of-type{border-top:0;}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{flex:1;}" + ( true ? "" : 0),  true ? "" : 0);
var optionBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;padding:", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var optionStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("margin:0;font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";line-height:", typographyStyle/* lineHeight.label */.Nv.label, ";color:", colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor, ";background-color:", colorStyle/* backgroundColor.secondaryLightColor */.Cz.secondaryLightColor, ";font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";padding:", spaceStyle/* space.atom0_5x */.D.atom0_5x, " ", spaceStyle/* space.atom1_5x */.D.atom1_5x, " 0.2rem;box-sizing:border-box;display:inline-block;" + ( true ? "" : 0),  true ? "" : 0);
var roomsLeftStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("margin:0;color:#fff;font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";line-height:", typographyStyle/* lineHeight.label */.Nv.label, ";background-color:", colorStyle/* accentColor.secondaryColor */.z.secondaryColor, ";padding:", spaceStyle/* space.atom0_5x */.D.atom0_5x, " ", spaceStyle/* space.atom1_5x */.D.atom1_5x, " 0.2rem;display:inline-block;text-align:center;box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0);
var priceBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("margin-left:auto;box-sizing:border-box;padding:", spaceStyle/* space.atom */.D.atom, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{width:60%;}" + ( true ? "" : 0),  true ? "" : 0);
var priceBlockInnerStyle =  true ? {
  name: "1k98ylq",
  styles: "display:flex;flex-wrap:wrap;align-items:center;box-sizing:border-box"
} : 0;
var priceStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("color:", colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor, ";font-size:", typographyStyle/* fontSize.headline */.JB.headline, ";font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";margin:0;flex:1;text-align:right;font-variant-numeric:tabular-nums;" + ( true ? "" : 0),  true ? "" : 0);
var reserveBlockStyle =  true ? {
  name: "1kcgx2p",
  styles: "position:relative;display:flex;flex-wrap:wrap"
} : 0;
var reserveBtnBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("width:114px;max-width:100%;padding:0 0 0 ", spaceStyle/* space.atom2x */.D.atom2x, ";" + ( true ? "" : 0),  true ? "" : 0);
var amenityBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, ";font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";width:100%;color:", colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor, ";box-sizing:border-box;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{width:40%;}" + ( true ? "" : 0),  true ? "" : 0);
var noteTextStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("width:100%;text-align:right;font-size:", typographyStyle/* fontSize.smallest */.JB.smallest, ";line-height:", typographyStyle/* lineHeight.caption3 */.Nv.caption3, ";color:rgba(45, 45, 45, 0.5);margin:0.15rem 0 0.5rem auto;" + ( true ? "" : 0),  true ? "" : 0);
var errorTextStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("width:100%;padding-top:", spaceStyle/* space.atom0_5x */.D.atom0_5x, ";font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";line-height:", typographyStyle/* lineHeight.caption3 */.Nv.caption3, ";text-align:right;color:", colorStyle/* accentColor.alertColor */.z.alertColor, ";" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/withTranslation.js
var withTranslation = __webpack_require__(91768);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Hotel/HotelBedInfo/HotelBedInfo.tsx







var HotelBedInfoComponent = function HotelBedInfoComponent(props) {
  var bedGroups = props.bedGroups,
      t = props.t;

  var renderBedTypes = function renderBedTypes() {
    return bedGroups.map(function (bedGroup, groupIndex) {
      return bedGroup.configurations.map(function (configuration, index) {
        var bedTypeSizeText = t("constant:hotelBedSizeType.".concat(configuration.sizeType));
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
          children: [index > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            children: " + "
          }), groupIndex > 0 && index === 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
            children: [" ", t("label:common.or"), " "]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            children: t("unit:".concat((0,humps.camelize)(configuration.bedType)), {
              type: bedTypeSizeText,
              count: configuration.count
            })
          })]
        }, index);
      });
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: renderBedTypes()
  });
};

var HotelBedInfo = /*#__PURE__*/react.memo((0,withTranslation/* withTranslation */.Z)(["label", "unit"])(HotelBedInfoComponent));
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Hotel/HotelBedInfo/index.ts

// EXTERNAL MODULE: ./main/javascripts/components/icon/Icon.tsx
var Icon = __webpack_require__(65147);
// EXTERNAL MODULE: ./main/javascripts/styles/base/borderStyle.ts
var borderStyle = __webpack_require__(58589);
// EXTERNAL MODULE: ./main/javascripts/styles/base/maxWidthStyle.ts
var maxWidthStyle = __webpack_require__(79105);
;// CONCATENATED MODULE: ./main/javascripts/features/hotel/components/hotelRoom/HotelRoomCard.tsx


var _templateObject;

function HotelRoomCard_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



















var HotelRoomCardComponent = function HotelRoomCardComponent(props) {
  var _hotelRoom$hotelPlans;

  var hotelRoom = props.hotelRoom,
      param = props.param,
      hotelId = props.hotelId,
      onClickDetail = props.onClickDetail,
      onSelectHotelPlan = props.onSelectHotelPlan,
      loggedInSocialMedia = props.loggedInSocialMedia;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["label"]),
      t = _useTranslation.t;

  var image = (0,hotelSlice/* defaultHotelRoomImage */.Ao)(hotelRoom);
  var imageStyle = image ? {
    backgroundImage: "url(\"".concat(image ? image.url : "", "\")")
  } : {};

  var onClickDetailButton = function onClickDetailButton() {
    if (hotelRoom.hotelRoomAmenities.length > 0 && onClickDetail) {
      onClickDetail({
        hotelId: hotelId,
        hotelRoom: hotelRoom
      });
    }
  };

  var detailBlockStyles = [detailBlockStyle, clickableStyle];
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Card */.Z, {
    styleKey: "cardNoHover",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: roomBlockStyle,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle/* CardTitle */.l, {
        children: props.hotelRoom.name
      }), image ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        style: imageStyle,
        css: roomImageStyle,
        onClick: onClickDetailButton,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: imageCountStyle,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            css: imageCountTextStyle,
            children: hotelRoom.hotelRoomImages.length
          }), " ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            css: imageCountIconStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
              styleKey: "images"
            })
          })]
        })
      }) : "", (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: detailBlockStyles,
        onClick: onClickDetailButton,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelBedInfo, {
            bedGroups: props.hotelRoom.bedGroups
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
          css: detailButtonStyle,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            css: detailButtonIconStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
              styleKey: "info"
            })
          }), " ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            css: detailButtonTextStyle,
            children: t("label:common.detail")
          })]
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: planBlockStyle,
      children: [(_hotelRoom$hotelPlans = hotelRoom.hotelPlans) === null || _hotelRoom$hotelPlans === void 0 ? void 0 : _hotelRoom$hotelPlans.map(function (hotelPlan, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelPlanContent, {
          hotelRoomId: hotelRoom.id,
          hotelId: hotelId,
          hotelPlan: hotelPlan,
          param: param,
          onSelectHotelPlan: onSelectHotelPlan,
          loggedInSocialMedia: loggedInSocialMedia
        }, index);
      }), (!hotelRoom.hotelPlans || hotelRoom.hotelPlans.length === 0) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: roomDescriptionStyle,
        dangerouslySetInnerHTML: {
          __html: hotelRoom.description
        }
      })]
    })]
  });
};

var HotelRoomCard = /*#__PURE__*/react.memo(HotelRoomCardComponent);
var imageKeyframes = (0,emotion_react_browser_esm.keyframes)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  0% {\n    opacity: 0;\n  }\n  10% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"])));
var roomBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom1_5x */.D.atom1_5x, " ", spaceStyle/* space.block */.D.block, " 0;max-width:", maxWidthStyle/* maxWidth.page1col */.k.page1col, ";margin:0 auto;box-sizing:border-box;width:100%;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{background-color:", colorStyle/* backgroundColor.primaryLightColor */.Cz.primaryLightColor, ";width:50%;padding-bottom:", spaceStyle/* space.atom */.D.atom, ";}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{width:40%;}" + ( true ? "" : 0),  true ? "" : 0);
var roomImageStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:relative;padding:56.25% 0 0;background-size:cover;background-position:center;margin:", spaceStyle/* space.atom */.D.atom, " -", spaceStyle/* space.atom */.D.atom, " 0;cursor:pointer;animation-name:", imageKeyframes, ";animation-duration:0.8s;animation-timing-function:ease;animation-fill-mode:forwards;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{padding:62.5% 0 0;margin:", spaceStyle/* space.atom */.D.atom, ";}" + ( true ? "" : 0),  true ? "" : 0);
var planBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;flex-direction:column;border-top:1px solid ", colorStyle/* borderColor.primaryLightColor */.tv.primaryLightColor, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{width:50%;border-top:0;border-left:1px solid ", colorStyle/* borderColor.primaryLightColor */.tv.primaryLightColor, ";}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{width:60%;}" + ( true ? "" : 0),  true ? "" : 0);
var detailBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;align-items:flex-start;justify-content:space-between;padding:", spaceStyle/* space.atom2x */.D.atom2x, " ", spaceStyle/* space.atom */.D.atom, ";font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";color:", colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor, ";line-height:1.5;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{padding:", spaceStyle/* space.atom0_5x */.D.atom0_5x, " ", spaceStyle/* space.atom */.D.atom, ";}" + ( true ? "" : 0),  true ? "" : 0);
var detailButtonStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("border:0;background:none;color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";cursor:pointer;margin-left:", spaceStyle/* space.atom2x */.D.atom2x, ";padding-left:", spaceStyle/* space.atom */.D.atom, ";outline:none;font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";text-align:right;flex:0 0 auto;display:flex;align-items:center;height:1.125rem;" + ( true ? "" : 0),  true ? "" : 0);
var detailButtonTextStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("line-height:", typographyStyle/* lineHeight.noSpace */.Nv.noSpace, ";" + ( true ? "" : 0),  true ? "" : 0);
var detailButtonIconStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:1.1875rem;padding-right:", spaceStyle/* space.atom0_5x */.D.atom0_5x, ";display:flex;align-items:center;padding-bottom:1px;" + ( true ? "" : 0),  true ? "" : 0);
var imageCountStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:absolute;top:", spaceStyle/* space.atom */.D.atom, ";right:", spaceStyle/* space.atom */.D.atom, ";background:rgba(0, 0, 0, 0.5);padding:0.25rem 0.5rem;color:#fff;display:flex;align-items:center;border-radius:", borderStyle/* borderRadius.normal */.E.normal, ";" + ( true ? "" : 0),  true ? "" : 0);
var imageCountTextStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";padding-right:", spaceStyle/* space.atom0_5x */.D.atom0_5x, ";" + ( true ? "" : 0),  true ? "" : 0);
var imageCountIconStyle =  true ? {
  name: "o3z2g7",
  styles: "font-size:1.1875rem"
} : 0;
var clickableStyle =  true ? {
  name: "e0dnmk",
  styles: "cursor:pointer"
} : 0;
var roomDescriptionStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom2x */.D.atom2x, " ", spaceStyle/* space.atom2x */.D.atom2x, ";font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";line-height:", typographyStyle/* lineHeight.caption2 */.Nv.caption2, ";color:", colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor, ";" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Icon/index.ts
var atoms_Icon = __webpack_require__(74303);
// EXTERNAL MODULE: ./main/javascripts/slices/paramSlice.ts
var paramSlice = __webpack_require__(9195);
;// CONCATENATED MODULE: ./main/javascripts/features/hotel/components/hotelRoom/HotelRoomParam.tsx
function HotelRoomParam_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var HotelRoomParam = function HotelRoomParam(props) {
  var param = props.param,
      displayForm = props.displayForm;

  var onClick = function onClick() {
    displayForm();
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: blockStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: dateBlockStyle,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: dateItemStyle,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: dateLabelStyle,
          children: "\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: dateStyle,
          children: param.checkinDate
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: dateItemStyle,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: dateLabelStyle,
          children: "\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: dateStyle,
          children: param.checkoutDate
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: numBlockStyle,
      children: [param.guests.length, "\u5BA4 / \u5927\u4EBA ", (0,paramSlice/* hotelShowParamTotalNumberOfAdult */.iT)(param), "\u4EBA / \u5B50\u4F9B ", (0,paramSlice/* hotelShowParamTotalNumberOfChildren */.ne)(param), "\u4EBA"]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
      css: linkSwitchStyle,
      onClick: onClick,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        css: linkIconStyle,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms_Icon/* Icon */.J, {
          styleKey: "arrowRight"
        })
      }), "\u6761\u4EF6\u3092\u5909\u66F4\u3059\u308B"]
    })]
  });
};
var blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, ";margin:0 auto;box-sizing:border-box;max-width:400px;text-align:center;" + ( true ? "" : 0),  true ? "" : 0);
var dateBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;align-items:center;font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";line-height:", typographyStyle/* lineHeight.caption2 */.Nv.caption2, ";padding-top:", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var dateItemStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("width:50%;border-right:1px solid ", colorStyle/* borderColor.primaryDarkColor */.tv.primaryDarkColor, ";&:last-of-type{border-right:0;}" + ( true ? "" : 0),  true ? "" : 0);
var dateLabelStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";text-align:center;" + ( true ? "" : 0),  true ? "" : 0);
var dateStyle =  true ? {
  name: "1nevnzz",
  styles: "box-sizing:border-box;text-align:center"
} : 0;
var numBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("text-align:center;font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";line-height:", typographyStyle/* lineHeight.caption1 */.Nv.caption1, ";padding-top:", spaceStyle/* space.atom */.D.atom, ";padding-bottom:", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var linkSwitchStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";line-height:", typographyStyle/* lineHeight.caption2 */.Nv.caption2, ";color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";cursor:pointer;" + ( true ? "" : 0),  true ? "" : 0);
var linkIconStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.smallest */.JB.smallest, ";padding-right:", spaceStyle/* space.atom0_5x */.D.atom0_5x, ";" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/components/card/CardTitle.tsx
var card_CardTitle = __webpack_require__(39733);
;// CONCATENATED MODULE: ./main/javascripts/components/hotel/HotelBedInfo.tsx







var HotelBedInfo_HotelBedInfoComponent = function HotelBedInfoComponent(props) {
  var bedGroups = props.bedGroups;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["label", "unit"]),
      t = _useTranslation.t;

  var renderBedTypes = function renderBedTypes() {
    return bedGroups.map(function (bedGroup, groupIndex) {
      return bedGroup.configurations.map(function (configuration, index) {
        var bedTypeSizeText = t("constant:hotelBedSizeType.".concat(configuration.sizeType));
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
          children: [index > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            children: " + "
          }), groupIndex > 0 && index === 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
            children: [" ", t("label:common.or"), " "]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            children: t("unit:".concat((0,humps.camelize)(configuration.bedType)), {
              type: bedTypeSizeText,
              count: configuration.count
            })
          })]
        }, index);
      });
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: renderBedTypes()
  });
};

var HotelBedInfo_HotelBedInfo = /*#__PURE__*/react.memo(HotelBedInfo_HotelBedInfoComponent);
;// CONCATENATED MODULE: ./main/javascripts/features/hotel/components/hotelRoom/SelectedHotelPlanDetail.tsx
function SelectedHotelPlanDetail_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

















var SelectedHotelPlanDetail = function SelectedHotelPlanDetail(props) {
  var selectedHotelId = props.selectedHotelId,
      selectedHotelRoom = props.selectedHotelRoom,
      selectedHotelPlan = props.selectedHotelPlan,
      onClickImage = props.onClickImage,
      onClickDetail = props.onClickDetail,
      param = props.param;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["label"]),
      t = _useTranslation.t;

  if (!selectedHotelRoom || !selectedHotelPlan) {
    return null;
  }

  var image = (0,hotelSlice/* defaultHotelRoomImage */.Ao)(selectedHotelRoom);
  var imageStyle = image ? {
    backgroundImage: "url(\"".concat(image ? image.url : "", "\")")
  } : {};

  var onClick = function onClick() {
    if (selectedHotelRoom.hotelRoomImages.length > 0 && onClickImage) {
      onClickImage(selectedHotelRoom.hotelRoomImages);
    }
  };

  var onClickDetailButton = function onClickDetailButton() {
    if (selectedHotelRoom.hotelRoomAmenities.length > 0 && onClickDetail) {
      onClickDetail({
        hotelId: selectedHotelId,
        hotelRoom: selectedHotelRoom
      });
    }
  };

  var hasDetail = selectedHotelRoom.hotelRoomAmenities && selectedHotelRoom.hotelRoomAmenities.length > 0;
  var detailBlockStyles = hasDetail ? [SelectedHotelPlanDetail_detailBlockStyle, SelectedHotelPlanDetail_clickableStyle] : SelectedHotelPlanDetail_detailBlockStyle;
  var onClickDetailBlock = hasDetail ? onClickDetailButton : undefined;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: cardStyle,
      children: [image ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: SelectedHotelPlanDetail_roomBlockStyle,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          style: imageStyle,
          css: SelectedHotelPlanDetail_roomImageStyle,
          onClick: onClick,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: SelectedHotelPlanDetail_imageCountStyle,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
              css: SelectedHotelPlanDetail_imageCountTextStyle,
              children: selectedHotelRoom.hotelRoomImages.length
            }), " ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
              css: SelectedHotelPlanDetail_imageCountIconStyle,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
                styleKey: "images"
              })
            })]
          })
        })
      }) : "", (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: SelectedHotelPlanDetail_planBlockStyle,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: titleBlockStyle,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: selectedLabelStyle,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
              css: checkedStyle
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
              css: selectedLabelTextStyle,
              children: "\u9078\u629E\u3057\u305F\u30D7\u30E9\u30F3"
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(card_CardTitle/* CardTitle */.l, {
            children: selectedHotelRoom.name
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: detailBlockStyles,
            onClick: onClickDetailBlock,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelBedInfo_HotelBedInfo, {
                bedGroups: selectedHotelRoom.bedGroups
              })
            }), hasDetail && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
              css: SelectedHotelPlanDetail_detailButtonStyle,
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                css: SelectedHotelPlanDetail_detailButtonIconStyle,
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
                  styleKey: "info"
                })
              }), " ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                css: SelectedHotelPlanDetail_detailButtonTextStyle,
                children: t("label:common.detail")
              })]
            })]
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelPlanContent, {
            hotelRoomId: selectedHotelRoom.id,
            hotelId: selectedHotelId,
            hotelPlan: selectedHotelPlan,
            param: param
          })
        })]
      })]
    })
  });
};
var SelectedHotelPlanDetail_roomBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("max-width:", maxWidthStyle/* maxWidth.page1col */.k.page1col, ";margin:0 auto;box-sizing:border-box;width:100%;padding:0;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{background-color:", colorStyle/* backgroundColor.primaryLightColor */.Cz.primaryLightColor, ";width:50%;display:flex;}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{width:40%;}" + ( true ? "" : 0),  true ? "" : 0);
var SelectedHotelPlanDetail_roomImageStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:56.25% 0 0;background-size:cover;position:relative;cursor:pointer;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{flex:1;padding:0;background-position:center;}" + ( true ? "" : 0),  true ? "" : 0);
var SelectedHotelPlanDetail_planBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;flex-direction:column;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{width:50%;border-top:0;border-left:1px solid ", colorStyle/* borderColor.primaryLightColor */.tv.primaryLightColor, ";flex:1;}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{width:60%;}" + ( true ? "" : 0),  true ? "" : 0);
var cardStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;flex-direction:column;overflow:hidden;position:relative;background:rgb(255, 255, 255);border-radius:", borderStyle/* borderRadius.normal */.E.normal, ";box-sizing:border-box;margin:3rem ", spaceStyle/* space.atom */.D.atom, " 2rem;min-height:0;flex-wrap:wrap;box-shadow:0 0 0 0.5rem #ddd;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{flex-direction:row;}" + ( true ? "" : 0),  true ? "" : 0);
var titleBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom1_5x */.D.atom1_5x, " ", spaceStyle/* space.atom */.D.atom, " 0;margin-bottom:-", spaceStyle/* space.atom0_5x */.D.atom0_5x, ";" + ( true ? "" : 0),  true ? "" : 0);
var selectedLabelStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";letter-spacing:0.1em;display:inline-block;position:relative;padding:", spaceStyle/* space.atom0_5x */.D.atom0_5x, " ", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var selectedLabelTextStyle =  true ? {
  name: "1989ovb",
  styles: "vertical-align:middle"
} : 0;
var checkedStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("background-color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";position:relative;margin-top:-1px;width:14px;height:14px;display:inline-block;border-radius:50%;margin-right:0.3rem;vertical-align:middle;&:after{content:\"\";display:block;width:3px;height:7px;border:solid #fff;border-width:0 2px 2px 0;transform:rotate(45deg);position:absolute;top:1px;left:5px;}" + ( true ? "" : 0),  true ? "" : 0);
var SelectedHotelPlanDetail_detailBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;align-items:flex-start;justify-content:space-between;padding:", spaceStyle/* space.atom2x */.D.atom2x, " ", spaceStyle/* space.atom */.D.atom, ";font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";color:", colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor, ";line-height:1.5;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{padding:", spaceStyle/* space.atom0_5x */.D.atom0_5x, " ", spaceStyle/* space.atom */.D.atom, ";}" + ( true ? "" : 0),  true ? "" : 0);
var SelectedHotelPlanDetail_detailButtonStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("border:0;background:none;color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";cursor:pointer;margin-left:", spaceStyle/* space.atom2x */.D.atom2x, ";padding-left:", spaceStyle/* space.atom */.D.atom, ";outline:none;font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";text-align:right;flex:0 0 auto;display:flex;align-items:center;height:1.125rem;" + ( true ? "" : 0),  true ? "" : 0);
var SelectedHotelPlanDetail_detailButtonTextStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("line-height:", typographyStyle/* lineHeight.noSpace */.Nv.noSpace, ";" + ( true ? "" : 0),  true ? "" : 0);
var SelectedHotelPlanDetail_detailButtonIconStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:1.1875rem;padding-right:", spaceStyle/* space.atom0_5x */.D.atom0_5x, ";display:flex;align-items:center;padding-bottom:1px;" + ( true ? "" : 0),  true ? "" : 0);
var SelectedHotelPlanDetail_imageCountStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:absolute;top:", spaceStyle/* space.atom */.D.atom, ";right:", spaceStyle/* space.atom */.D.atom, ";background:rgba(0, 0, 0, 0.5);padding:0.25rem 0.5rem;color:#fff;display:flex;align-items:center;border-radius:", borderStyle/* borderRadius.normal */.E.normal, ";" + ( true ? "" : 0),  true ? "" : 0);
var SelectedHotelPlanDetail_imageCountTextStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";padding-right:", spaceStyle/* space.atom0_5x */.D.atom0_5x, ";" + ( true ? "" : 0),  true ? "" : 0);
var SelectedHotelPlanDetail_imageCountIconStyle =  true ? {
  name: "o3z2g7",
  styles: "font-size:1.1875rem"
} : 0;
var SelectedHotelPlanDetail_clickableStyle =  true ? {
  name: "e0dnmk",
  styles: "cursor:pointer"
} : 0;
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./main/javascripts/components/button/Button.tsx
var Button = __webpack_require__(95284);
// EXTERNAL MODULE: ./main/javascripts/components/hotel/HotelDatePickerBlock.tsx
var HotelDatePickerBlock = __webpack_require__(65562);
// EXTERNAL MODULE: ./main/javascripts/components/hotel/GuestsBlock.tsx + 3 modules
var GuestsBlock = __webpack_require__(88452);
// EXTERNAL MODULE: ./main/javascripts/utils/HotelUtil.ts
var HotelUtil = __webpack_require__(66479);
// EXTERNAL MODULE: ./main/javascripts/constants/FormConstants.ts
var FormConstants = __webpack_require__(36581);
// EXTERNAL MODULE: ./main/javascripts/features/hotel/searchHotelSlice.ts
var searchHotelSlice = __webpack_require__(9296);
;// CONCATENATED MODULE: ./main/javascripts/features/hotel/components/hotelRoom/HotelRoomSearchForm.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function HotelRoomSearchForm_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




 // import isEqual from "react-fast-compare";




















yup_es/* setLocale */.i_(FormConstants/* yupDefaultMessages */.b);
var schema = yup_es/* object */.Ry().shape({
  checkin_date: yup_es/* string */.Z_().nullable().required(),
  checkout_date: yup_es/* string */.Z_().nullable().required(),
  guests: yup_es/* array */.IX().of(yup_es/* object */.Ry().shape({
    number_of_children: yup_es/* number */.Rx().nullable().transform(function (_, val) {
      return val || val === 0 ? Number(val) : null;
    }).required(),
    ages_of_children: yup_es/* array */.IX().when("number_of_children", {
      is: function is(val) {
        return Number(val) > 0;
      },
      then: yup_es/* array */.IX().of(yup_es/* object */.Ry().shape({
        age: yup_es/* number */.Rx().nullable().transform(function (_, val) {
          return val || val === 0 ? Number(val) : null;
        }).required()
      }))
    })
  }))
});
var HotelRoomSearchForm = function HotelRoomSearchForm() {
  var appDispatch = (0,store/* useAppDispatch */.TL)();
  var router = (0,next_router.useRouter)(); // public shouldComponentUpdate(nextProps: any, nextState: any): boolean {
  //   return !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);
  // }

  var hotelId = (0,store/* useAppSelector */.CG)(hotelSlice/* hotelIdSelector */.GM);
  var param = (0,store/* useAppSelector */.CG)(paramSlice/* hotelShowParamSelector */.C3);
  var isLoading = (0,store/* useAppSelector */.CG)(searchHotelSlice/* loadingSelector */.E2);
  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onBlur",
    resolver: (0,yup/* yupResolver */.X)(schema),
    defaultValues: (0,paramSlice/* hotelShowParamToFormValues */.lU)(param)
  });
  var handleSubmit = methods.handleSubmit,
      clearErrors = methods.clearErrors;

  var handleFormSubmit = function handleFormSubmit(e) {
    e.preventDefault();
    clearErrors("form");
    handleSubmit(onSubmit)(e);
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(values) {
      var submitValues;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              appDispatch((0,hotelSlice/* setIsLoadingRoom */.zj)(true));
              appDispatch((0,hotelSlice/* setRequestRoomError */.Xb)(null));
              submitValues = (0,hotelSlice/* convertHotelSearchFormValuesToParams */.AE)(values);
              appDispatch((0,hotelSlice/* fetchHotelRooms */.qN)({
                hotelId: hotelId,
                param: (0,lib.stringify)(submitValues, {
                  arrayFormat: "indices"
                })
              })).then(redux_toolkit_esm/* unwrapResult */.SI).then(function (result) {
                var newParam = _objectSpread(_objectSpread({}, submitValues), {}, {
                  cache_id: param.cacheId,
                  room_cache_id: result.roomCacheId
                });

                appDispatch((0,paramSlice/* initHotelShowParam */.nR)((0,humps.camelizeKeys)(newParam)));
                (0,HotelUtil/* updateHotelShowUrl */.EJ)(newParam, router);
                appDispatch((0,hotelSlice/* setIsLoadingRoom */.zj)(false));
              })["catch"](function (error) {
                appDispatch((0,hotelSlice/* setRequestRoomError */.Xb)(error));
                appDispatch((0,hotelSlice/* setIsLoadingRoom */.zj)(false));
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: HotelRoomSearchForm_blockStyle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: innerStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* FormProvider */.RV, _objectSpread(_objectSpread({}, methods), {}, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
          onSubmit: handleFormSubmit,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelDatePickerBlock/* HotelDatePickerBlock */.F, {
            labelColorStyleKey: "default"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuestsBlock/* GuestsBlock */.J, {
            isGuestMultipleColumn: false
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: submitBlockStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              css: buttonStyle,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                type: "submit",
                disabled: isLoading,
                children: "\u66F4\u65B0\u3059\u308B"
              })
            })
          })]
        })
      }))
    })
  });
};
var submitBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, " 0 ", spaceStyle/* space.atom2x */.D.atom2x, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{width:50%;margin:0 auto;}" + ( true ? "" : 0),  true ? "" : 0);
var buttonStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var HotelRoomSearchForm_blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("background-color:", colorStyle/* backgroundColor.secondaryLightColor */.Cz.secondaryLightColor, ";padding:", spaceStyle/* space.atom */.D.atom, " 0;box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0);
var innerStyle =  true ? {
  name: "1w7bo27",
  styles: "max-width:600px;margin:0 auto"
} : 0;
// EXTERNAL MODULE: ./main/javascripts/components/molecules/Modal/SocialWebViewSelectionModalDialog/index.ts + 4 modules
var SocialWebViewSelectionModalDialog = __webpack_require__(64400);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Card/CardStyle.ts
var CardStyle = __webpack_require__(39587);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/Card/Card.tsx


var _excluded = ["styles", "children", "styleKey"];

function Card_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Card_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Card_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Card_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Card_Card = function Card(props) {
  var styles = props.styles,
      children = props.children,
      _props$styleKey = props.styleKey,
      styleKey = _props$styleKey === void 0 ? "card" : _props$styleKey,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", Card_objectSpread(Card_objectSpread({
    className: (0,aphrodite_es/* css */.iv)(CardStyle/* CardStyle */.U[styleKey], styles)
  }, rest), {}, {
    children: children
  }));
};
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/Card/index.ts

// EXTERNAL MODULE: ./main/javascripts/components/skeleton/RectSkeleton.tsx
var RectSkeleton = __webpack_require__(66356);
;// CONCATENATED MODULE: ./main/javascripts/features/hotel/components/hotelRoom/HotelRoomCardSkeleton.tsx
function HotelRoomCardSkeleton_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var HotelRoomCardSkeleton = function HotelRoomCardSkeleton() {
  var planCount = 2;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card_Card, {
    styleKey: "cardNoHover",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: HotelRoomCardSkeleton_roomBlockStyle,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: titleSkeletonStyle,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RectSkeleton/* RectSkeleton */.I, {})
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: HotelRoomCardSkeleton_roomImageStyle,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: imageSkeletonStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RectSkeleton/* RectSkeleton */.I, {})
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: HotelRoomCardSkeleton_planBlockStyle,
      children: Array.from(Array(planCount)).map(function (_, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: HotelRoomCardSkeleton_planItemStyle,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: planOptionSkeletonStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RectSkeleton/* RectSkeleton */.I, {})
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: planOptionSkeletonStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RectSkeleton/* RectSkeleton */.I, {})
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: planPriceSkeletonStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RectSkeleton/* RectSkeleton */.I, {})
          })]
        }, index);
      })
    })]
  });
};
var HotelRoomCardSkeleton_roomBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.block2x */.D.block2x, " ", spaceStyle/* space.block */.D.block, " 0;max-width:", maxWidthStyle/* maxWidth.page1col */.k.page1col, ";margin:0 auto;box-sizing:border-box;width:100%;padding-top:", spaceStyle/* space.atom1_5x */.D.atom1_5x, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{background-color:", colorStyle/* backgroundColor.primaryLightColor */.Cz.primaryLightColor, ";width:50%;padding-bottom:", spaceStyle/* space.atom */.D.atom, ";}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{width:40%;}" + ( true ? "" : 0),  true ? "" : 0);
var HotelRoomCardSkeleton_roomImageStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:relative;padding:56.25% 0 0;margin:", spaceStyle/* space.atom */.D.atom, " -", spaceStyle/* space.atom */.D.atom, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{padding:62.5% 0 0;margin:", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom3x */.D.atom3x, ";}" + ( true ? "" : 0),  true ? "" : 0);
var HotelRoomCardSkeleton_planBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;flex-direction:column;border-top:1px solid ", colorStyle/* borderColor.primaryLightColor */.tv.primaryLightColor, ";margin-top:", spaceStyle/* space.atom2x */.D.atom2x, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{margin-top:0;width:50%;border-top:0;border-left:1px solid ", colorStyle/* borderColor.primaryLightColor */.tv.primaryLightColor, ";}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{width:60%;}" + ( true ? "" : 0),  true ? "" : 0);
var HotelRoomCardSkeleton_planItemStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("border-top:1px solid ", colorStyle/* borderColor.primaryLightColor */.tv.primaryLightColor, ";padding:", spaceStyle/* space.atom2x */.D.atom2x, ";&:first-of-type{border-top:0;}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{flex:1;}" + ( true ? "" : 0),  true ? "" : 0);
var titleSkeletonStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("width:50%;height:1.5rem;margin:", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var imageSkeletonStyle =  true ? {
  name: "zbshhy",
  styles: "width:100%;height:100%;position:absolute;top:0;left:0;margin:0"
} : 0;
var planOptionSkeletonStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("width:25%;height:1.125rem;margin-bottom:", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var planPriceSkeletonStyle =  true ? {
  name: "18kddkn",
  styles: "width:30%;height:2rem;margin:1rem 0 0 auto"
} : 0;
;// CONCATENATED MODULE: ./main/javascripts/features/hotel/components/HotelRoomNotAvailableMessage.tsx







var HotelRoomNotAvailableMessage = function HotelRoomNotAvailableMessage() {
  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["component"]),
      t = _useTranslation.t;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: HotelRoomNotAvailableMessage_blockStyle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: HotelRoomNotAvailableMessage_innerStyle,
      children: t("hotelShow.roomNotAvailableMessage")
    })
  });
};
var HotelRoomNotAvailableMessage_blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:0 ", spaceStyle/* space.atom */.D.atom, ";margin:5rem auto;max-width:35rem;" + ( true ? "" : 0),  true ? "" : 0);
var HotelRoomNotAvailableMessage_innerStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom3x */.D.atom3x, " ", spaceStyle/* space.atom2x */.D.atom2x, ";text-align:center;font-size:", typographyStyle/* fontSize.body */.JB.body, ";font-weight:", typographyStyle/* fontWeight.medium */.Ue.medium, ";line-height:", typographyStyle/* lineHeight.body2 */.Nv.body2, ";background:rgba(0, 0, 0, 0.025);border-radius:", borderStyle/* borderRadius.normal */.E.normal, ";" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./node_modules/redux-actions/es/createAction.js + 1 modules
var createAction = __webpack_require__(88231);
// EXTERNAL MODULE: ./node_modules/normalizr/dist/normalizr.es.js
var normalizr_es = __webpack_require__(82677);
// EXTERNAL MODULE: ./main/javascripts/schemas/ImageSchema.ts
var ImageSchema = __webpack_require__(64949);
;// CONCATENATED MODULE: ./main/javascripts/schemas/HotelSchema.ts


var HotelSchema = new normalizr_es/* schema.Entity */.fK.Entity("hotel", {
  images: [ImageSchema/* ImageSchema */.K]
});
var HotelsSchema = new normalizr_es/* schema.Object */.fK.Object({
  hotels: [HotelSchema]
});
var HotelForMapSchema = new normalizr_es/* schema.Entity */.fK.Entity("hotelForMap", {
  images: [ImageSchema/* ImageSchema */.K]
});
var HotelsForMapSchema = new normalizr_es/* schema.Object */.fK.Object({
  hotels: [HotelForMapSchema]
});
// EXTERNAL MODULE: ./main/javascripts/constants/actionType/HotelActionType.ts
var HotelActionType = __webpack_require__(34208);
;// CONCATENATED MODULE: ./main/javascripts/actions/Hotels.ts



var initHotel = (0,createAction/* default */.Z)(HotelActionType/* INIT_HOTEL */.cM, function (hotel) {
  return hotel;
}, function () {
  return {
    schema: HotelSchema
  };
});
var initHotels = (0,createAction/* default */.Z)(HotelActionType/* INIT_HOTELS */.TB, function (param) {
  return param;
}, function () {
  return {
    schema: HotelsSchema
  };
});
var setHotelRooms = (0,createAction/* default */.Z)(HotelActionType/* SET_HOTEL_ROOMS */.u4, function (param) {
  return param;
});
var setHotelImage = (0,createAction/* default */.Z)(HotelActionType/* SET_HOTEL_IMAGE */.Oq, function (image) {
  return image;
});
var pollingHotelsRequest = (0,createAction/* default */.Z)(HotelActionType/* POLLING_HOTELS_REQUEST */.sm);
var pollingHotelsFailure = (0,createAction/* default */.Z)(HotelActionType/* POLLING_HOTELS_FAILURE */.kO);
var pollingHotelsSuccess = (0,createAction/* default */.Z)(HotelActionType/* POLLING_HOTELS_SUCCESS */.NX, function (param) {
  return param;
}, function () {
  return {
    schema: HotelsSchema
  };
});
var setIsHotelMapView = (0,createAction/* default */.Z)(HotelActionType/* SET_IS_HOTEL_SHOW_MAP_VIEW */.QI, function (showMapView) {
  return showMapView;
});
var pollingHotelsForMapRequest = (0,createAction/* default */.Z)(HotelActionType/* POLLING_HOTELS_FOR_MAP_REQUEST */.Ss);
var pollingHotelsForMapFailure = (0,createAction/* default */.Z)(HotelActionType/* POLLING_HOTELS_FOR_MAP_FAILURE */.zx);
var pollingHotelsForMapSuccess = (0,createAction/* default */.Z)(HotelActionType/* POLLING_HOTELS_FOR_MAP_SUCCESS */.sG, function (param) {
  return param;
}, function () {
  return {
    schema: HotelsForMapSchema
  };
});
var setHotelMapCoordinates = (0,createAction/* default */.Z)(HotelActionType/* SET_HOTEL_MAP_COORDINATES */.u2, function (centerCoordinates) {
  return centerCoordinates;
});
var setDisplayHotelSearchForm = (0,createAction/* default */.Z)(HotelActionType/* SET_DISPLAY_HOTEL_SEARCH_FORM */.bC, function (param) {
  return param;
});
var setDisplayHotelImageModal = (0,createAction/* default */.Z)(HotelActionType/* SET_DISPLAY_HOTEL_IMAGE_MODAL */.LK, function (isDisplayed) {
  return isDisplayed;
});
var setDisplayHotelRoomImageModal = (0,createAction/* default */.Z)(HotelActionType/* SET_DISPLAY_HOTEL_ROOM_IMAGE_MODAL */.tZ, function (isDisplayed) {
  return isDisplayed;
});
var setHotelRoomModalImages = (0,createAction/* default */.Z)(HotelActionType/* SET_HOTEL_ROOM_MODAL_IMAGES */.L9, function (images) {
  return images;
});
var setDisplayHotelRoomDetailModal = (0,createAction/* default */.Z)(HotelActionType/* SET_DISPLAY_HOTEL_ROOM_DETAIL_MODAL */.HX, function (isDisplayed) {
  return isDisplayed;
});
var setHotelRoomModalDetails = (0,createAction/* default */.Z)(HotelActionType/* SET_HOTEL_ROOM_MODAL_DETAILS */.xl, function (param) {
  return param;
});
var setIsLoadingRoom = (0,createAction/* default */.Z)(HotelActionType/* SET_IS_LOADING_ROOM */.wc, function (isLoadingRoom) {
  return isLoadingRoom;
});
var setRequestRoomError = (0,createAction/* default */.Z)(HotelActionType/* SET_REQUEST_ROOM_ERROR */.b0, function (error) {
  return error;
});
;// CONCATENATED MODULE: ./main/javascripts/features/hotel/components/hotelRoom/HotelRoomListWithSelectedPlan.tsx


























var HotelRoomListWithSelectedPlanComponent = function HotelRoomListWithSelectedPlanComponent() {
  var appDispatch = (0,store/* useAppDispatch */.TL)();
  var hotel = (0,store/* useAppSelector */.CG)(hotelSlice/* hotelSelector */.XS);
  var selectedHotelRoom = (0,store/* useAppSelector */.CG)(hotelSlice/* selectedHotelRoomSelector */.ug);
  var selectedHotelPlan = (0,store/* useAppSelector */.CG)(hotelSlice/* selectedHotelPlanSelector */.I0);
  var param = (0,store/* useAppSelector */.CG)(paramSlice/* hotelShowParamSelector */.C3);
  var isLoadingRoom = (0,store/* useAppSelector */.CG)(hotelSlice/* isLoadingRoomSelector */.q0);
  var requestRoomError = (0,store/* useAppSelector */.CG)(hotelSlice/* requestRoomErrorSelector */.aF);
  var initializedLIFF = (0,store/* useAppSelector */.CG)(currentUserSlice/* isLIFFInitializedInSelector */.BR);
  var initializedFacebookMessenger = (0,store/* useAppSelector */.CG)(currentUserSlice/* isFacebookMessengerInitializedInSelector */.x3);
  var loggedInSocialMedia = (0,store/* useAppSelector */.CG)(currentUserSlice/* loggedInSocialMediaSelector */.H5);

  var _useState = (0,react.useState)(false),
      isDisplayedForm = _useState[0],
      setIsDisplayedForm = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isSelected = _useState2[0],
      setIsSelected = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      hasCostMessage = _useState3[0],
      setHasCostMessage = _useState3[1];

  var displayForm = function displayForm() {
    setIsDisplayedForm(true);
  };

  var hideForm = function hideForm() {
    setIsDisplayedForm(false);
  };

  var onClickRoomImage = function onClickRoomImage(images) {
    appDispatch(setHotelRoomModalImages(images));
    appDispatch((0,hotelSlice/* setDisplayHotelRoomImageModal */.av)(true));
  };

  var onClickRoomDetail = function onClickRoomDetail(data) {
    appDispatch((0,hotelSlice/* setHotelRoomModalDetails */.CQ)(data));
    appDispatch((0,hotelSlice/* setDisplayHotelRoomDetailModal */.RN)(true));
  };

  var onSelectHotelPlan = function onSelectHotelPlan(hasCostMessage) {
    setIsSelected(true);
    setHasCostMessage(hasCostMessage);
  };

  var selectionModalCloseHandler = function selectionModalCloseHandler() {
    setIsSelected(false);
  };

  var renderSelectedHotelPlan = function renderSelectedHotelPlan() {
    return selectedHotelRoom && selectedHotelPlan ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectedHotelPlanDetail, {
      param: param,
      selectedHotelId: hotel.id,
      selectedHotelRoom: selectedHotelRoom,
      selectedHotelPlan: selectedHotelPlan,
      onClickImage: onClickRoomImage,
      onClickDetail: onClickRoomDetail
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: stockNoticeTextStyle,
      children: "\u30C1\u30E3\u30C3\u30C8\u3067\u3054\u6848\u5185\u3057\u305F\u30D7\u30E9\u30F3\u306F\u58F2\u308A\u5207\u308C\u306B\u306A\u308A\u307E\u3057\u305F"
    });
  };

  var renderList = function renderList() {
    var roomCount = 3;

    if (requestRoomError) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelRoomNotAvailableMessage, {});
    }

    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [hotel.hotelRooms && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [renderSelectedHotelPlan(), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: priceNoticeBlockStyle,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            css: priceNoticeIconStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
              styleKey: "caution"
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            css: priceNoticeTextStyle,
            children: "\u6599\u91D1\u306F\u5E38\u306B\u5909\u52D5\u3057\u3066\u3044\u307E\u3059\u3002\u30C1\u30E3\u30C3\u30C8\u306E\u3010\u5408\u8A08\u6599\u91D1\u3011\u3068\u306E\u5DEE\u984D\u304C\u8868\u793A\u3055\u308C\u3066\u3044\u307E\u3059\u3002"
          })]
        })]
      }), !isLoadingRoom ? hotel.hotelRooms.map(function (hotelRoom) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelRoomCard, {
          hotelId: hotel.id,
          hotelRoom: hotelRoom,
          param: param,
          onClickImage: onClickRoomImage,
          onClickDetail: onClickRoomDetail,
          onSelectHotelPlan: onSelectHotelPlan,
          loggedInSocialMedia: loggedInSocialMedia
        }, hotelRoom.id);
      }) : Array.from(Array(roomCount)).map(function (_, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelRoomCardSkeleton, {}, index);
      })]
    });
  };

  if (!hotel.isEan) {
    return null;
  }

  var isNoParam = function isNoParam() {
    if (!param.checkinDate && !param.checkoutDate) {
      return true;
    }

    return false;
  }; // TODO: SocialWebViewSelectionModalDialogは旧コンポーネントを使用している


  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: roomListBlockStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialWebViewSelectionModalDialog/* SocialWebViewSelectionModalDialog */.d, {
      displayed: isSelected,
      closeHandler: selectionModalCloseHandler,
      selectionType: "hotel",
      initializedFacebookMessenger: initializedFacebookMessenger,
      initializedLIFF: initializedLIFF,
      hasCostMessage: hasCostMessage
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: roomListInnerStyle,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
        css: headlineStyle,
        children: "\u5BA2\u5BA4\u3092\u9078\u629E"
      }), isDisplayedForm || isNoParam() ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelRoomSearchForm, {}), !isNoParam() ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: linkBlockStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
            css: HotelRoomListWithSelectedPlan_linkSwitchStyle,
            onClick: hideForm,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
              css: HotelRoomListWithSelectedPlan_linkIconStyle,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
                styleKey: "close"
              })
            }), "\u5909\u66F4\u3092\u30AD\u30E3\u30F3\u30BB\u30EB"]
          })
        }) : ""]
      }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelRoomParam, {
          param: param,
          displayForm: displayForm
        })
      }), renderList()]
    })]
  });
};

var HotelRoomListWithSelectedPlan_areEqual = function areEqual(prevProps, nextProps) {
  return react_fast_compare_default()(prevProps, nextProps);
};

var HotelRoomListWithSelectedPlan = /*#__PURE__*/react.memo(HotelRoomListWithSelectedPlanComponent, HotelRoomListWithSelectedPlan_areEqual);
var arrowSize = "0.8rem";
var headlineStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("line-height:", typographyStyle/* lineHeight.headline2 */.Nv.headline2, ";padding:calc(\n      ", spaceStyle/* space.atom */.D.atom, " - (", typographyStyle/* lineHeight.headline2 */.Nv.headline2, " - ", typographyStyle/* fontSize.headline */.JB.headline, ") / 2\n    ) ", spaceStyle/* space.atom */.D.atom, " 0;margin:0;font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";color:", colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor, ";font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";text-align:center;letter-spacing:0.2em;" + ( true ? "" : 0),  true ? "" : 0);
var linkBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("text-align:center;margin-top:-", spaceStyle/* space.atom2x */.D.atom2x, ";" + ( true ? "" : 0),  true ? "" : 0);
var roomListBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("max-width:100%;box-sizing:border-box;background-color:", colorStyle/* backgroundColor.secondaryLightColor */.Cz.secondaryLightColor, ";position:relative;margin-top:", spaceStyle/* space.atom2x */.D.atom2x, ";padding:", spaceStyle/* space.atom */.D.atom, " 0 0;&:before{content:\"\";position:absolute;top:0;left:50%;display:block;width:0;height:0;border-left:", arrowSize, " solid transparent;border-right:", arrowSize, " solid transparent;border-top:", arrowSize, " solid white;transform:translateX(-50%);}" + ( true ? "" : 0),  true ? "" : 0);
var roomListInnerStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.block2x */.D.block2x, " ", spaceStyle/* space.block */.D.block, ";max-width:", maxWidthStyle/* maxWidth.page1col */.k.page1col, ";margin:0 auto;box-sizing:border-box;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{max-width:", maxWidthStyle/* maxWidth.page1colWide */.k.page1colWide, ";}" + ( true ? "" : 0),  true ? "" : 0);
var priceNoticeBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom2x */.D.atom2x, " ", spaceStyle/* space.atom2x */.D.atom2x, ";border-top:2px solid #ddd;border-bottom:2px solid #ddd;margin:", spaceStyle/* space.atom3x */.D.atom3x, " ", spaceStyle/* space.atom */.D.atom, ";text-align:center;font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{padding:", spaceStyle/* space.atom2x */.D.atom2x, ";margin:", spaceStyle/* space.atom3x */.D.atom3x, " ", spaceStyle/* space.atom3x */.D.atom3x, ";}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{font-size:", typographyStyle/* fontSize.body */.JB.body, ";}" + ( true ? "" : 0),  true ? "" : 0);
var priceNoticeIconStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.large */.JB.large, ";vertical-align:middle;display:block;padding-bottom:", spaceStyle/* space.atom */.D.atom, ";opacity:0.3;margin-top:-1px;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{font-size:", typographyStyle/* fontSize.headline */.JB.headline, ";padding-right:", spaceStyle/* space.atom */.D.atom, ";padding-bottom:0;display:inline-block;}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{margin-top:0;}" + ( true ? "" : 0),  true ? "" : 0);
var priceNoticeTextStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("vertical-align:middle;font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";" + ( true ? "" : 0),  true ? "" : 0);
var stockNoticeTextStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.body */.JB.body, ";font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";color:", colorStyle/* accentColor.secondaryColor */.z.secondaryColor, ";letter-spacing:0.1em;text-align:center;padding:", spaceStyle/* space.atom3x */.D.atom3x, " ", spaceStyle/* space.atom2x */.D.atom2x, ";margin:2rem ", spaceStyle/* space.atom */.D.atom, " 0;background:rgba(0, 0, 0, 0.025);border-radius:", borderStyle/* borderRadius.normal */.E.normal, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";}" + ( true ? "" : 0),  true ? "" : 0);
var HotelRoomListWithSelectedPlan_linkSwitchStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";line-height:", typographyStyle/* lineHeight.caption2 */.Nv.caption2, ";color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";cursor:pointer;" + ( true ? "" : 0),  true ? "" : 0);
var HotelRoomListWithSelectedPlan_linkIconStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.smallest */.JB.smallest, ";padding-right:", spaceStyle/* space.atom0_5x */.D.atom0_5x, ";" + ( true ? "" : 0),  true ? "" : 0);
;// CONCATENATED MODULE: ./main/javascripts/components/spot/DetailItem.tsx


var DetailItem_excluded = ["title", "children"];

function DetailItem_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DetailItem_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DetailItem_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DetailItem_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var DetailItem = function DetailItem(props) {
  var title = props.title,
      children = props.children,
      rest = (0,objectWithoutProperties/* default */.Z)(props, DetailItem_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", DetailItem_objectSpread(DetailItem_objectSpread({
    css: DetailItem_blockStyle
  }, rest), {}, {
    children: [title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
      css: titleStyle,
      children: title
    }), children]
  }));
};
var DetailItem_blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom2x */.D.atom2x, " 0;color:", colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var titleStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.subHeading */.JB.subHeading, ";line-height:", typographyStyle/* lineHeight.subHeadline2 */.Nv.subHeadline2, ";padding:", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
;// CONCATENATED MODULE: ./main/javascripts/components/spot/DetailItemList.tsx








var DetailItemListComponent = function DetailItemListComponent(props) {
  var listData = props.listData;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
    css: listStyle,
    children: listData.map(function (text, index) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
        css: listItemStyle,
        children: text
      }, index);
    })
  });
};

var DetailItemList_areEqual = function areEqual(prevProps, nextProps) {
  return react_fast_compare_default()(prevProps, nextProps);
};

var DetailItemList = /*#__PURE__*/react.memo(DetailItemListComponent, DetailItemList_areEqual);
var listStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("list-style-type:square;margin:0;padding:0 ", spaceStyle/* space.atom */.D.atom, " 0 2em;font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";line-height:", typographyStyle/* lineHeight.caption1 */.Nv.caption1, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{display:flex;flex-wrap:wrap;justify-content:space-between;}" + ( true ? "" : 0),  true ? "" : 0);
var listItemStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:0.32rem 0;line-height:", typographyStyle/* lineHeight.caption3 */.Nv.caption3, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{width:48%;}" + ( true ? "" : 0),  true ? "" : 0);
;// CONCATENATED MODULE: ./main/javascripts/components/spot/DetailItemText.tsx




var DetailItemText = function DetailItemText(props) {
  var children = props.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: textBlockStyle,
    children: children
  });
};
var textBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:0 ", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
;// CONCATENATED MODULE: ./main/javascripts/components/hotel/HotelCheckin.tsx





var HotelCheckin = function HotelCheckin(props) {
  var checkin = props.checkin;

  if (!checkin) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DetailItem, {
    title: "\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3",
    children: [checkin.beginTime ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DetailItemText, {
      children: ["\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u958B\u59CB\u6642\u523B : ", checkin.beginTime]
    }) : "", checkin.endTime ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DetailItemText, {
      children: ["\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u7D42\u4E86\u6642\u523B : ", checkin.endTime]
    }) : "", checkin.minAge ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DetailItemText, {
      children: ["\u6700\u4F4E\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u5E74 : ", checkin.minAge]
    }) : "", checkin.instructions || checkin.specialInstructions ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DetailItemText, {
      children: ["\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u306B\u95A2\u3059\u308B\u7279\u8A18\u4E8B\u9805 : ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), checkin.instructions ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        dangerouslySetInnerHTML: {
          __html: checkin.instructions
        }
      }) : "", checkin.instructions && checkin.specialInstructions ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}) : "", checkin.specialInstructions ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        dangerouslySetInnerHTML: {
          __html: checkin.specialInstructions
        }
      }) : ""]
    }) : ""]
  });
};
;// CONCATENATED MODULE: ./main/javascripts/components/hotel/HotelCheckout.tsx





var HotelCheckout = function HotelCheckout(props) {
  var checkout = props.checkout;

  if (!checkout || checkout === "") {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DetailItem, {
    title: "\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DetailItemText, {
      children: ["\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8\u6642\u523B : ", checkout]
    })
  });
};
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
;// CONCATENATED MODULE: ./main/javascripts/components/spot/CollapseDetailItem.tsx



var CollapseDetailItem_excluded = ["title", "children"];

function CollapseDetailItem_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CollapseDetailItem_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CollapseDetailItem_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CollapseDetailItem_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function CollapseDetailItem_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var CollapseDetailItem = function CollapseDetailItem(props) {
  var title = props.title,
      children = props.children,
      rest = (0,objectWithoutProperties/* default */.Z)(props, CollapseDetailItem_excluded);

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["button"]),
      t = _useTranslation.t;

  var _React$useState = react.useState(true),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      isCollapsed = _React$useState2[0],
      setIsCollapsed = _React$useState2[1];

  var onClick = function onClick() {
    setIsCollapsed(!isCollapsed);
  };

  var innerCollapsedStyles = title ? innerCollapsedStyleWithTitle : innerCollapsedStyle;
  var innerStyles = isCollapsed ? innerCollapsedStyles : CollapseDetailItem_innerStyle;
  var buttonText = isCollapsed ? t("common.showAll") : t("common.showLess");
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", CollapseDetailItem_objectSpread(CollapseDetailItem_objectSpread({
    css: CollapseDetailItem_blockStyle
  }, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: innerStyles,
      children: [title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
        css: CollapseDetailItem_titleStyle,
        children: title
      }), children]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: buttonBlockStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        css: CollapseDetailItem_buttonStyle,
        onClick: onClick,
        children: buttonText
      })
    })]
  }));
};
var CollapseDetailItem_blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom2x */.D.atom2x, " 0;color:", colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var CollapseDetailItem_titleStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.subHeading */.JB.subHeading, ";line-height:", typographyStyle/* lineHeight.subHeadline2 */.Nv.subHeadline2, ";padding:", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var CollapseDetailItem_innerStyle =  true ? {
  name: "pit38s",
  styles: "height:auto"
} : 0;
var innerCollapsedStyle =  true ? {
  name: "1rb8xbf",
  styles: "height:3rem;position:relative;overflow:hidden;mask-image:linear-gradient(0deg, transparent, black 2rem)"
} : 0;
var innerCollapsedStyleWithTitle = /*#__PURE__*/(0,emotion_react_browser_esm.css)(innerCollapsedStyle, ";height:5.5rem;mask-image:linear-gradient(0deg, transparent, black 2rem);" + ( true ? "" : 0),  true ? "" : 0);
var buttonBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;justify-content:flex-start;padding:", spaceStyle/* space.atom1_5x */.D.atom1_5x, " ", spaceStyle/* space.atom */.D.atom, " 0;" + ( true ? "" : 0),  true ? "" : 0);
var CollapseDetailItem_buttonStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";cursor:pointer;text-decoration:underline;text-underline-offset:0.5rem;" + ( true ? "" : 0),  true ? "" : 0);
;// CONCATENATED MODULE: ./main/javascripts/features/hotel/components/HotelDetails.tsx
function HotelDetails_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


















var HotelDetailsComponent = function HotelDetailsComponent(props) {
  var hotel = props.hotel;
  var checkin = hotel.checkin,
      checkout = hotel.checkout;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["component"]),
      t = _useTranslation.t;

  if (!hotel.isEan) {
    return null;
  }

  var amenityNames = hotel.hotelAmenities.map(function (amenity) {
    return amenity.name;
  });
  var hasFacilityDetails = hotel.roomDescription || hotel.amenityDescription || hotel.diningDescription;
  var hasLocationDetails = hotel.headlineDescription || hotel.locationDescription || hotel.attractionDescription;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: HotelDetails_blockStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: groupBlockStyle,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
        css: HotelDetails_headlineStyle,
        children: t("hotelShow.hotelFacilitiesAndServices")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DetailItem, {
        title: t("hotelShow.facilitiesAndServices"),
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DetailItemList, {
          listData: amenityNames
        })
      }), hasFacilityDetails && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollapseDetailItem, {
        children: [hotel.roomDescription && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DetailItemText, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: detailTextStyle,
            dangerouslySetInnerHTML: {
              __html: hotel.roomDescription
            }
          })
        }), hotel.amenityDescription && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DetailItemText, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: detailTextStyle,
            dangerouslySetInnerHTML: {
              __html: hotel.amenityDescription
            }
          })
        }), hotel.diningDescription && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DetailItemText, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            dangerouslySetInnerHTML: {
              __html: hotel.diningDescription
            }
          })
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: groupBlockStyle,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
        css: HotelDetails_headlineStyle,
        children: t("hotelShow.hotelPolicies")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelCheckin, {
        checkin: checkin
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelCheckout, {
        checkout: checkout
      }), hotel.policyDescription && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DetailItem, {
        title: t("common.others"),
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DetailItemText, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            dangerouslySetInnerHTML: {
              __html: hotel.policyDescription
            }
          })
        })
      }), (hotel.feeDescription || hotel.mandatoryFeeDescription) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DetailItem, {
        title: t("hotelShow.serviceChargesAndOptionalFees"),
        children: [hotel.feeDescription && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DetailItemText, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            dangerouslySetInnerHTML: {
              __html: hotel.feeDescription
            }
          })
        }), hotel.mandatoryFeeDescription && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DetailItemText, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            dangerouslySetInnerHTML: {
              __html: hotel.mandatoryFeeDescription
            }
          })
        })]
      })]
    }), hasLocationDetails && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: groupBlockStyle,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
        css: HotelDetails_headlineStyle,
        children: t("hotelShow.localGuide")
      }), hotel.locationDescription && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DetailItem, {
        title: hotel.headlineDescription,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DetailItemText, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            dangerouslySetInnerHTML: {
              __html: hotel.locationDescription
            }
          })
        })
      }), hotel.attractionDescription && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollapseDetailItem, {
        title: t("hotelShow.localInformation"),
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DetailItemText, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            dangerouslySetInnerHTML: {
              __html: hotel.attractionDescription
            }
          })
        })
      })]
    })]
  });
};

var HotelDetails_areEqual = function areEqual(prevProps, nextProps) {
  return react_fast_compare_default()(prevProps, nextProps);
};

var HotelDetails = /*#__PURE__*/react.memo(HotelDetailsComponent, HotelDetails_areEqual);
var HotelDetails_blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";line-height:", typographyStyle/* lineHeight.caption1 */.Nv.caption1, ";" + ( true ? "" : 0),  true ? "" : 0);
var groupBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, " 0 ", spaceStyle/* space.atom1_5x */.D.atom1_5x, ";&:before{content:\"\";display:block;border-top:1px solid ", colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor, ";margin:0 ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom3x */.D.atom3x, ";}&:first-of-type:before{content:none;}" + ( true ? "" : 0),  true ? "" : 0);
var HotelDetails_headlineStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("line-height:", typographyStyle/* lineHeight.headline2 */.Nv.headline2, ";padding:", spaceStyle/* space.atom2x */.D.atom2x, " ", spaceStyle/* space.atom */.D.atom, ";margin:0;font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";color:", colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor, ";font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";text-align:center;letter-spacing:0.2em;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{font-size:", typographyStyle/* fontSize.headline */.JB.headline, ";font-weight:", typographyStyle/* fontWeight.medium */.Ue.medium, ";}" + ( true ? "" : 0),  true ? "" : 0);
var detailTextStyle =  true ? {
  name: "1mn7kwb",
  styles: "padding-bottom:1em"
} : 0;
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(45959);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/DynamicPackage/DynamicPackageStepIndicator/DynamicPackageStepIndicatorStyle.ts






var DynamicPackageStepIndicatorStyle = aphrodite_es/* StyleSheet.create */.mM.create({
  block: {
    padding: "".concat(spaceStyle/* space.atom2x */.D.atom2x, " 0 ").concat(spaceStyle/* space.atom */.D.atom)
  },
  progress: (0,defineProperty/* default */.Z)({
    textAlign: "center",
    padding: "".concat(spaceStyle/* space.atom */.D.atom, " 0"),
    margin: "0 auto",
    position: "relative",
    width: "318px"
  }, (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), {
    width: "420px"
  }),
  bar: (0,defineProperty/* default */.Z)({
    position: "absolute",
    top: "calc(16px + 0.5rem)",
    left: "53px",
    height: "6px",
    width: "212px",
    background: colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor,
    transform: "translateY(-50%)"
  }, (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), {
    left: "70px",
    width: "280px"
  }),
  barActive: (0,defineProperty/* default */.Z)({
    position: "absolute",
    top: "calc(16px + 0.5rem)",
    left: "53px",
    height: "6px",
    width: "212px",
    background: colorStyle/* accentColor.primaryColor */.z.primaryColor,
    transform: "translateY(-50%)",
    transformOrigin: "top left"
  }, (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), {
    left: "70px",
    width: "280px"
  }),
  barActive1: {
    transform: "translateY(-50%) scaleX(0)"
  },
  barActive2: {
    transform: "translateY(-50%) scaleX(0.5)"
  },
  barActive3: {
    transform: "translateY(-50%) scaleX(1)"
  },
  item: (0,defineProperty/* default */.Z)({
    display: "inline-block",
    textAlign: "center",
    width: "106px",
    verticalAlign: "top"
  }, (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), {
    width: "140px"
  }),
  itemNumber: {
    position: "relative",
    width: "32px",
    height: "32px",
    textAlign: "center",
    lineHeight: "24px",
    fontSize: typographyStyle/* fontSize.subHeading */.JB.subHeading,
    fontWeight: typographyStyle/* fontWeight.bold */.Ue.bold,
    background: colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor,
    borderRadius: "16px",
    border: "4px solid ".concat(colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor),
    display: "block",
    margin: "0 auto",
    boxSizing: "border-box",
    zIndex: 1
  },
  itemNumberDone: {
    color: "#fff",
    background: colorStyle/* accentColor.primaryColor */.z.primaryColor,
    borderColor: colorStyle/* accentColor.primaryColor */.z.primaryColor
  },
  itemNumberActive: {
    color: colorStyle/* accentColor.primaryColor */.z.primaryColor,
    background: "#fff",
    borderColor: colorStyle/* accentColor.primaryColor */.z.primaryColor
  },
  itemText: (0,defineProperty/* default */.Z)({
    padding: "".concat(spaceStyle/* space.atom0_5x */.D.atom0_5x, " ").concat(spaceStyle/* space.atom0_5x */.D.atom0_5x, " 0"),
    fontSize: typographyStyle/* fontSize.smallest */.JB.smallest,
    fontWeight: typographyStyle/* fontWeight.bold */.Ue.bold,
    textAlign: "center",
    color: colorStyle/* textColor.disabledColor */.zP.disabledColor,
    display: "inline-block"
  }, (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), {
    fontSize: typographyStyle/* fontSize.caption */.JB.caption
  }),
  itemTextActive: {
    color: colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor
  },
  title: (0,defineProperty/* default */.Z)({
    fontSize: typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading,
    lineHeight: typographyStyle/* lineHeight.mediumHeadline2 */.Nv.mediumHeadline2,
    fontWeight: typographyStyle/* fontWeight.bold */.Ue.bold,
    textAlign: "center",
    letterSpacing: "0.05em",
    padding: "".concat(spaceStyle/* space.atom */.D.atom, " ").concat(spaceStyle/* space.atom2x */.D.atom2x, " 0")
  }, (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), {
    fontSize: typographyStyle/* fontSize.headline */.JB.headline,
    lineHeight: typographyStyle/* lineHeight.headline2 */.Nv.headline2
  })
});
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/DynamicPackage/DynamicPackageStepIndicator/DynamicPackageStepIndicator.tsx






function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }







var barActiveClassArray = [DynamicPackageStepIndicatorStyle.barActive1, DynamicPackageStepIndicatorStyle.barActive2, DynamicPackageStepIndicatorStyle.barActive3];
var itemNumberActiveClass = [DynamicPackageStepIndicatorStyle.itemNumber, DynamicPackageStepIndicatorStyle.itemNumberActive];
var itemNumberDoneClass = [DynamicPackageStepIndicatorStyle.itemNumber, DynamicPackageStepIndicatorStyle.itemNumberDone];
var itemTextActiveClass = [DynamicPackageStepIndicatorStyle.itemText, DynamicPackageStepIndicatorStyle.itemTextActive];
var itemData = ["dynamicPackage.chooseFlight", "dynamicPackage.chooseHotel", "dynamicPackage.chooseRoom"];
var titleData = ["dynamicPackage.indicatorFlight", "dynamicPackage.indicatorHotel", "dynamicPackage.indicatorRoom"];

var DynamicPackageStepIndicatorComponent = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(DynamicPackageStepIndicatorComponent, _React$Component);

  var _super = _createSuper(DynamicPackageStepIndicatorComponent);

  function DynamicPackageStepIndicatorComponent() {
    (0,classCallCheck/* default */.Z)(this, DynamicPackageStepIndicatorComponent);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(DynamicPackageStepIndicatorComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          step = _this$props.step,
          _this$props$styles = _this$props.styles,
          styles = _this$props$styles === void 0 ? {} : _this$props$styles,
          t = _this$props.t;
      var blockStyle = styles.blockStyle;
      var barActiveClass = [DynamicPackageStepIndicatorStyle.barActive, barActiveClassArray[step - 1]];
      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: (0,aphrodite_es/* css */.iv)(DynamicPackageStepIndicatorStyle.block, blockStyle),
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          className: (0,aphrodite_es/* css */.iv)(DynamicPackageStepIndicatorStyle.progress),
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            className: (0,aphrodite_es/* css */.iv)(DynamicPackageStepIndicatorStyle.bar)
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            className: (0,aphrodite_es/* css */.iv)(barActiveClass)
          }), itemData.map(function (data, index) {
            var itemNumberClass = DynamicPackageStepIndicatorStyle.itemNumber;

            if (step === index + 1) {
              itemNumberClass = itemNumberActiveClass;
            } else if (step > index + 1) {
              itemNumberClass = itemNumberDoneClass;
            }

            var itemTextClass = index + 1 === step ? itemTextActiveClass : DynamicPackageStepIndicatorStyle.itemText;
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              className: (0,aphrodite_es/* css */.iv)(DynamicPackageStepIndicatorStyle.item),
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                className: (0,aphrodite_es/* css */.iv)(itemNumberClass),
                children: index + 1
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                className: (0,aphrodite_es/* css */.iv)(itemTextClass),
                children: t(data)
              })]
            }, index);
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          className: (0,aphrodite_es/* css */.iv)(DynamicPackageStepIndicatorStyle.title),
          children: t(titleData[step - 1])
        })]
      });
    }
  }]);

  return DynamicPackageStepIndicatorComponent;
}(react.Component);

var DynamicPackageStepIndicator = (0,withTranslation/* withTranslation */.Z)(["component", "label"])(DynamicPackageStepIndicatorComponent);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/DynamicPackage/DynamicPackageStepIndicator/index.ts

// EXTERNAL MODULE: ./main/javascripts/components/molecules/Modal/SearchModalDialog/SearchModalDialog.tsx + 1 modules
var SearchModalDialog = __webpack_require__(48439);
// EXTERNAL MODULE: ./main/javascripts/components/consultation/SearchConsultationEntry.tsx
var SearchConsultationEntry = __webpack_require__(56556);
;// CONCATENATED MODULE: ./main/javascripts/features/hotel/components/hotelRoom/HotelRoomList.tsx


function HotelRoomList_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function HotelRoomList_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? HotelRoomList_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : HotelRoomList_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



























var HotelRoomListComponent = function HotelRoomListComponent() {
  var appDispatch = (0,store/* useAppDispatch */.TL)();
  var hotel = (0,store/* useAppSelector */.CG)(hotelSlice/* hotelSelector */.XS);
  var param = (0,store/* useAppSelector */.CG)(paramSlice/* hotelShowParamSelector */.C3);
  var isLoadingRoom = (0,store/* useAppSelector */.CG)(hotelSlice/* isLoadingRoomSelector */.q0);
  var requestRoomError = (0,store/* useAppSelector */.CG)(hotelSlice/* requestRoomErrorSelector */.aF);
  var initializedLIFF = (0,store/* useAppSelector */.CG)(currentUserSlice/* isLIFFInitializedInSelector */.BR);
  var initializedFacebookMessenger = (0,store/* useAppSelector */.CG)(currentUserSlice/* isFacebookMessengerInitializedInSelector */.x3);
  var loggedInSocialMedia = (0,store/* useAppSelector */.CG)(currentUserSlice/* loggedInSocialMediaSelector */.H5);
  var currentUser = (0,store/* useAppSelector */.CG)(currentUserSlice/* currentUserSelector */.ib);

  var _useState = (0,react.useState)(false),
      isDisplayedForm = _useState[0],
      setIsDisplayedForm = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isSelected = _useState2[0],
      setIsSelected = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      hasCostMessage = _useState3[0],
      setHasCostMessage = _useState3[1];

  var isDynamicPackage = param.searchType === SearchTypes/* SearchTypes.dynamicPackage */.a.dynamicPackage;
  var isSelectionMode = (0,paramSlice/* hotelShowParamIsSelectionMode */.ad)(param);

  var displayForm = function displayForm() {
    setIsDisplayedForm(true);
  };

  var hideForm = function hideForm() {
    setIsDisplayedForm(false);
  };

  var onClickRoomDetail = function onClickRoomDetail(data) {
    var detailData = HotelRoomList_objectSpread(HotelRoomList_objectSpread({}, data), {}, {
      onSelectHotelPlan: onSelectHotelPlan
    });

    appDispatch((0,hotelSlice/* setHotelRoomModalDetails */.CQ)(detailData));
    appDispatch((0,hotelSlice/* setDisplayHotelRoomDetailModal */.RN)(true));
  };

  var onSelectHotelPlan = function onSelectHotelPlan(hasCostMessage) {
    setIsSelected(true);
    setHasCostMessage(hasCostMessage);
  };

  var selectionModalCloseHandler = function selectionModalCloseHandler() {
    setIsSelected(false);
  };

  var renderList = function renderList() {
    var _hotel$hotelRooms;

    var roomCount = 3;

    if (requestRoomError) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelRoomNotAvailableMessage, {});
    }

    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: !isLoadingRoom ? (_hotel$hotelRooms = hotel.hotelRooms) === null || _hotel$hotelRooms === void 0 ? void 0 : _hotel$hotelRooms.map(function (hotelRoom) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelRoomCard, {
          hotelId: hotel.id,
          hotelRoom: hotelRoom,
          param: param,
          onClickDetail: onClickRoomDetail,
          onSelectHotelPlan: onSelectHotelPlan,
          loggedInSocialMedia: loggedInSocialMedia
        }, hotelRoom.id);
      }) : Array.from(Array(roomCount)).map(function (_, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelRoomCardSkeleton, {}, index);
      })
    });
  };

  if (!hotel.isEan) {
    return null;
  }

  var isNoParam = function isNoParam() {
    if (!param.checkinDate && !param.checkoutDate) {
      return true;
    }

    return false;
  };

  var selectionType = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.chatPlatformType) === PlatformTypes/* PlatformTypes.email */.A.email ? "hotelEmail" : "hotel"; // TODO: SocialWebViewSelectionModalDialogは旧コンポーネントを使用している

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: HotelRoomList_roomListBlockStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialWebViewSelectionModalDialog/* SocialWebViewSelectionModalDialog */.d, {
      displayed: isSelected,
      closeHandler: selectionModalCloseHandler,
      selectionType: selectionType,
      initializedFacebookMessenger: initializedFacebookMessenger,
      initializedLIFF: initializedLIFF,
      hasCostMessage: hasCostMessage
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: HotelRoomList_roomListInnerStyle,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
        css: HotelRoomList_headlineStyle,
        children: "\u5BA2\u5BA4\u3092\u9078\u629E"
      }), isDisplayedForm || isNoParam() ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelRoomSearchForm, {}), !isNoParam() ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: HotelRoomList_linkBlockStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
            css: HotelRoomList_linkSwitchStyle,
            onClick: hideForm,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
              css: HotelRoomList_linkIconStyle,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
                styleKey: "close"
              })
            }), "\u5909\u66F4\u3092\u30AD\u30E3\u30F3\u30BB\u30EB"]
          })
        }) : ""]
      }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelRoomParam, {
          param: param,
          displayForm: displayForm
        })
      }), renderList()]
    }), isDynamicPackage && !isSelectionMode && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: searchConsultationEntryBlockStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchConsultationEntry/* SearchConsultationEntry */.p, {
        pageType: "hotelShow",
        searchCacheId: param.cacheId,
        dynamicPackageId: param.dynamicPackageId,
        dynamicPackagePreReservationId: param.dynamicPackagePreReservationId,
        hotelId: hotel.id,
        hotelName: hotel.name
      })
    })]
  });
};

var HotelRoomList_areEqual = function areEqual(prevProps, nextProps) {
  return react_fast_compare_default()(prevProps, nextProps);
};

var HotelRoomList = /*#__PURE__*/react.memo(HotelRoomListComponent, HotelRoomList_areEqual);
var HotelRoomList_arrowSize = "0.8rem";
var HotelRoomList_headlineStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("line-height:", typographyStyle/* lineHeight.headline2 */.Nv.headline2, ";padding:calc(\n      ", spaceStyle/* space.atom */.D.atom, " - (", typographyStyle/* lineHeight.headline2 */.Nv.headline2, " - ", typographyStyle/* fontSize.headline */.JB.headline, ") / 2\n    ) ", spaceStyle/* space.atom */.D.atom, " 0;margin:0;font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";color:", colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor, ";font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";text-align:center;letter-spacing:0.2em;" + ( true ? "" : 0),  true ? "" : 0);
var HotelRoomList_linkBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("text-align:center;margin-top:-", spaceStyle/* space.atom2x */.D.atom2x, ";" + ( true ? "" : 0),  true ? "" : 0);
var HotelRoomList_roomListBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("max-width:100%;box-sizing:border-box;background-color:", colorStyle/* backgroundColor.secondaryLightColor */.Cz.secondaryLightColor, ";position:relative;margin-top:", spaceStyle/* space.atom2x */.D.atom2x, ";padding:", spaceStyle/* space.atom */.D.atom, " 0 0;&:before{content:\"\";position:absolute;top:0;left:50%;display:block;width:0;height:0;border-left:", HotelRoomList_arrowSize, " solid transparent;border-right:", HotelRoomList_arrowSize, " solid transparent;border-top:", HotelRoomList_arrowSize, " solid white;transform:translateX(-50%);}" + ( true ? "" : 0),  true ? "" : 0);
var HotelRoomList_roomListInnerStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.block2x */.D.block2x, " ", spaceStyle/* space.block */.D.block, ";max-width:", maxWidthStyle/* maxWidth.page1col */.k.page1col, ";margin:0 auto;box-sizing:border-box;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{max-width:", maxWidthStyle/* maxWidth.page1colWide */.k.page1colWide, ";}" + ( true ? "" : 0),  true ? "" : 0);
var HotelRoomList_linkSwitchStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";line-height:", typographyStyle/* lineHeight.caption2 */.Nv.caption2, ";color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";cursor:pointer;" + ( true ? "" : 0),  true ? "" : 0);
var HotelRoomList_linkIconStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.smallest */.JB.smallest, ";padding-right:", spaceStyle/* space.atom0_5x */.D.atom0_5x, ";" + ( true ? "" : 0),  true ? "" : 0);
var searchConsultationEntryBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding-bottom:", spaceStyle/* space.atom3x */.D.atom3x, ";" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/components/molecules/Modal/FullScreenModalDialog/index.ts + 2 modules
var FullScreenModalDialog = __webpack_require__(19484);
// EXTERNAL MODULE: ./main/javascripts/components/spot/ImageListWithThumbnail.tsx
var ImageListWithThumbnail = __webpack_require__(26161);
;// CONCATENATED MODULE: ./main/javascripts/features/hotel/components/HotelImageModal.tsx
function HotelImageModal_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var HotelImageModal = function HotelImageModal() {
  var appDispatch = (0,store/* useAppDispatch */.TL)();
  var imageData = (0,store/* useAppSelector */.CG)(hotelSlice/* hotelImagesSelector */.OF);
  var isDisplayed = (0,store/* useAppSelector */.CG)(hotelSlice/* isDisplayedImageModalSelector */.Hp);

  var closeHandler = function closeHandler() {
    appDispatch((0,hotelSlice/* setDisplayHotelImageModal */.dQ)(false));
  };

  var imageListStyles = {
    exBlockStyle: slideBlockStyle,
    exGallerySliderStyle: gallerySliderBlockStyle
  };
  return (// TODO: 旧コンポーネント使用中
    (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FullScreenModalDialog/* FullScreenModalDialog */.H, {
      displayed: isDisplayed,
      closeHandler: closeHandler,
      children: imageData && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageListWithThumbnail/* ImageListWithThumbnail */.Q, {
        images: imageData,
        styles: imageListStyles
      })
    })
  );
};
var slideBlockStyle =  true ? {
  name: "12i03va",
  styles: "max-width:90vw;max-height:90vh"
} : 0;
var gallerySliderBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)(".swiper-wrapper{height:calc(70vh - 10rem);", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{height:calc(90vh - 10rem);}}" + ( true ? "" : 0),  true ? "" : 0);
;// CONCATENATED MODULE: ./main/javascripts/features/hotel/components/hotelRoom/HotelRoomDetailModal.tsx
function HotelRoomDetailModal_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




















var HotelRoomDetailModal = function HotelRoomDetailModal() {
  var appDispatch = (0,store/* useAppDispatch */.TL)();

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["label"]),
      t = _useTranslation.t;

  var roomDetailData = (0,store/* useAppSelector */.CG)(hotelSlice/* roomDetailModalDataSelector */.Ui);
  var isDisplayed = (0,store/* useAppSelector */.CG)(hotelSlice/* isDisplayedRoomDetailModalSelector */.mX);
  var param = (0,store/* useAppSelector */.CG)(paramSlice/* hotelShowParamSelector */.C3);
  var loggedInSocialMedia = (0,store/* useAppSelector */.CG)(currentUserSlice/* loggedInSocialMediaSelector */.H5); // TODO: 旧reducer

  var breakpoint = (0,es/* useSelector */.v9)(function (state) {
    return state.breakpointReducer.breakpoint;
  });

  var closeHandler = function closeHandler() {
    appDispatch((0,hotelSlice/* setDisplayHotelRoomDetailModal */.RN)(false));
  };

  var onSelectHotelPlan = function onSelectHotelPlan(hasCostMessage) {
    if (roomDetailData.onSelectHotelPlan) {
      roomDetailData.onSelectHotelPlan(hasCostMessage);
      appDispatch((0,hotelSlice/* setDisplayHotelRoomDetailModal */.RN)(false));
    }
  };

  var renderAmenities = function renderAmenities() {
    var hotelRoom = roomDetailData.hotelRoom;

    if (hotelRoom && hotelRoom.hotelRoomAmenities) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: facilityBlockStyle,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: nameStyle,
          children: hotelRoom.name
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: facilityItemStyle,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: facilityTitleStyle,
            children: t("label:hotel.bedType")
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: facilityContentStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelBedInfo_HotelBedInfo, {
              bedGroups: hotelRoom.bedGroups
            })
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: facilityItemStyle,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: facilityTitleStyle,
            children: t("label:hotel.roomAmenity")
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
            css: amenityListStyle,
            children: hotelRoom.hotelRoomAmenities.map(function (amenity, index) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                css: amenityListItemStyle,
                children: amenity
              }, index);
            })
          })]
        })]
      });
    }

    return null;
  };

  var renderPlans = function renderPlans() {
    var hotelId = roomDetailData.hotelId,
        hotelRoom = roomDetailData.hotelRoom;

    if (hotelRoom && hotelRoom.hotelRoomAmenities) {
      var _hotelRoom$hotelPlans;

      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: HotelRoomDetailModal_planBlockStyle,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
          css: planTitleStyle,
          children: "\u304A\u90E8\u5C4B\u306E\u30D7\u30E9\u30F3"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: planInnerStyle,
          children: (_hotelRoom$hotelPlans = hotelRoom.hotelPlans) === null || _hotelRoom$hotelPlans === void 0 ? void 0 : _hotelRoom$hotelPlans.map(function (hotelPlan, index) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelPlanContent, {
              hotelRoomId: hotelRoom.id,
              hotelId: hotelId,
              hotelPlan: hotelPlan,
              param: param,
              onSelectHotelPlan: onSelectHotelPlan,
              loggedInSocialMedia: loggedInSocialMedia
            }, index);
          })
        })]
      });
    }

    return null;
  };

  var renderImages = function renderImages() {
    var hotelRoom = roomDetailData.hotelRoom;
    var imageListOptions = {
      autoplay: false
    };
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageList/* ImageList */.Y, {
        images: hotelRoom.hotelRoomImages,
        options: imageListOptions
      })
    });
  };

  var renderHeader = function renderHeader() {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: headerStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: headerTitleStyle,
        children: "\u90E8\u5C4B\u60C5\u5831"
      })
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FullScreenModalDialog/* FullScreenModalDialog */.H, {
    displayed: isDisplayed,
    closeHandler: closeHandler,
    colorMode: "light",
    header: renderHeader(),
    children: roomDetailData && roomDetailData.hotelRoom && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: scrollerStyle,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: HotelRoomDetailModal_innerStyle,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: firstBlockStyle,
            children: [!(0,responsiveStyle/* isDesktop */.nI)(breakpoint) && renderImages(), renderAmenities()]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: secondBlockStyle,
            children: [(0,responsiveStyle/* isDesktop */.nI)(breakpoint) && renderImages(), renderPlans()]
          })]
        })
      })
    })
  });
};
var headerStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:absolute;width:100%;height:3rem;border-bottom:1px solid ", colorStyle/* borderColor.primaryLightColor */.tv.primaryLightColor, ";z-index:10;top:0;left:0;padding:0 ", spaceStyle/* space.atom1_5x */.D.atom1_5x, ";box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0);
var headerTitleStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";letter-spacing:0.05em;padding:", spaceStyle/* space.atom1_5x */.D.atom1_5x, " ", spaceStyle/* space.atom */.D.atom, ";color:", colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{padding:", spaceStyle/* space.atom1_5x */.D.atom1_5x, ";}" + ( true ? "" : 0),  true ? "" : 0);
var scrollerStyle =  true ? {
  name: "1lkx2zj",
  styles: "height:100%;overflow-y:auto;-webkit-overflow-scrolling:touch"
} : 0;
var HotelRoomDetailModal_innerStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, " 0;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{padding:", spaceStyle/* space.atom */.D.atom, " 2vw;}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{display:flex;max-width:90rem;margin:0 auto;padding:", spaceStyle/* space.atom */.D.atom, ";}" + ( true ? "" : 0),  true ? "" : 0);
var firstBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{width:40%;}" + ( true ? "" : 0),  true ? "" : 0);
var secondBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{width:60%;}" + ( true ? "" : 0),  true ? "" : 0);
var facilityBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.body */.JB.body, ";color:", colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var nameStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.headline */.JB.headline, ";color:", colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor, ";font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";padding:", spaceStyle/* space.atom2x */.D.atom2x, " ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom */.D.atom, ";margin-bottom:", spaceStyle/* space.atom */.D.atom, ";&:after{content:\"\";display:block;width:calc(100% - ", spaceStyle/* space.atom2x */.D.atom2x, ");height:1px;background-color:", colorStyle/* borderColor.primaryLightColor */.tv.primaryLightColor, ";margin-top:", spaceStyle/* space.atom2x */.D.atom2x, ";}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{font-size:", typographyStyle/* fontSize.title */.JB.title, ";}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{padding-top:", spaceStyle/* space.atom */.D.atom, ";}" + ( true ? "" : 0),  true ? "" : 0);
var facilityItemStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:0 0 ", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var facilityTitleStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("color:", colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor, ";font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";padding:", spaceStyle/* space.atom2x */.D.atom2x, " ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom0_5x */.D.atom0_5x, ";" + ( true ? "" : 0),  true ? "" : 0);
var facilityContentStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var amenityListStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("list-style-type:square;margin:0;font-size:", typographyStyle/* fontSize.body */.JB.body, ";line-height:", typographyStyle/* lineHeight.body1 */.Nv.body1, ";display:flex;flex-wrap:wrap;padding:", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var amenityListItemStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:relative;list-style:none;padding:", spaceStyle/* space.atom0_5x */.D.atom0_5x, " ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom0_5x */.D.atom0_5x, " ", spaceStyle/* space.atom2_5x */.D.atom2_5x, ";width:calc(100% - ", spaceStyle/* space.atom2_5x */.D.atom2_5x, ");box-sizing:border-box;&:before{content:\"\";display:block;position:absolute;width:", spaceStyle/* space.atom1_5x */.D.atom1_5x, ";height:1px;background-color:", colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor, ";left:0;top:1em;}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{width:calc(50% - ", spaceStyle/* space.atom2_5x */.D.atom2_5x, ");}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{width:calc(100% - ", spaceStyle/* space.atom2_5x */.D.atom2_5x, ");}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("widescreen"), "{width:calc(50% - ", spaceStyle/* space.atom2_5x */.D.atom2_5x, ");}" + ( true ? "" : 0),  true ? "" : 0);
var HotelRoomDetailModal_planBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom2x */.D.atom2x, " ", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var planInnerStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("border:1px solid ", colorStyle/* borderColor.primaryLightColor */.tv.primaryLightColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var planTitleStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.headline */.JB.headline, ";font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";letter-spacing:0.05em;padding:", spaceStyle/* space.atom */.D.atom, " 0 ", spaceStyle/* space.atom2x */.D.atom2x, ";" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/features/dynamicPackage/searchDynamicPackageSlice.ts
var searchDynamicPackageSlice = __webpack_require__(90266);
;// CONCATENATED MODULE: ./main/javascripts/features/hotel/components/HotelShowMain.tsx




function HotelShowMain_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function HotelShowMain_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? HotelShowMain_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : HotelShowMain_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }































var HotelShowMainComponent = function HotelShowMainComponent() {
  var appDispatch = (0,store/* useAppDispatch */.TL)();
  var router = (0,next_router.useRouter)();
  var hotel = (0,store/* useAppSelector */.CG)(hotelSlice/* hotelSelector */.XS);
  var param = (0,store/* useAppSelector */.CG)(paramSlice/* hotelShowParamSelector */.C3);
  var selectedHotelPlan = (0,store/* useAppSelector */.CG)(hotelSlice/* selectedHotelPlanSelector */.I0);
  var isDynamicPackage = !!param.dynamicPackageId;
  var expirationTimerRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)(false),
      isExpired = _useState[0],
      setIsExpired = _useState[1];

  var checkExpiration = function checkExpiration() {
    if ((0,paramSlice/* isCacheIdExpired */.dR)(param.dynamicPackageId)) {
      setIsExpired(true);
    }
  };

  (0,react.useEffect)(function () {
    if (!param.valid) {
      // appDispatch(setRequestRoomError({ errors: {} })); // null以外を設定
      return;
    }

    if (isDynamicPackage) {
      expirationTimerRef.current = setInterval(function () {
        checkExpiration();
      }, 10000);
      checkExpiration();
    }

    appDispatch((0,hotelSlice/* setIsLoadingRoom */.zj)(true));
    appDispatch((0,hotelSlice/* setRequestRoomError */.Xb)(null));
    appDispatch((0,hotelSlice/* fetchHotelRooms */.qN)({
      hotelId: hotel.id,
      param: (0,paramSlice/* hotelShowParamToApiQueryParam */.bV)(param)
    })).then(redux_toolkit_esm/* unwrapResult */.SI).then(function (result) {
      appDispatch((0,paramSlice/* initHotelShowParam */.nR)(HotelShowMain_objectSpread(HotelShowMain_objectSpread({}, param), {}, {
        roomCacheId: result.roomCacheId
      })));
      appDispatch((0,hotelSlice/* setIsLoadingRoom */.zj)(false));
    })["catch"](function (error) {
      appDispatch((0,hotelSlice/* setRequestRoomError */.Xb)(error));
      appDispatch((0,hotelSlice/* setIsLoadingRoom */.zj)(false));
    });
    return function () {
      if (isDynamicPackage) {
        clearInterval(expirationTimerRef.current);
      }
    };
  }, []);

  var onImageListClick = function onImageListClick() {
    appDispatch((0,hotelSlice/* setDisplayHotelImageModal */.dQ)(true));
  };

  var refreshHandler = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", appDispatch((0,searchDynamicPackageSlice/* postResearchDynamicPackageCache */.Ui)({
                cacheId: param.dynamicPackageId
              })).then(redux_toolkit_esm/* unwrapResult */.SI).then(function (result) {
                router.push("/flights?".concat((0,lib.stringify)((0,humps.decamelizeKeys)(result.data.conditions), {
                  arrayFormat: "indices"
                }), "&cache_id=").concat(result.data.cacheId, "&dynamic_package_id=").concat(result.data.dynamicPackageId, "&search_group_id=").concat(result.data.searchGroupId, "&search_type=dp"));
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function refreshHandler() {
      return _ref.apply(this, arguments);
    };
  }();

  var imageListStyles = {
    exBlockStyle: imageListBlockStyle
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MainBlock/* MainBlock */.R, {
    children: [isDynamicPackage ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicPackageStepIndicator, {
      step: 3,
      styles: {
        blockStyle: MainStyle.stepIndicatorBlock
      }
    }) : "", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: imageBlockStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageList/* ImageList */.Y, {
        images: hotel.hotelImages,
        styles: imageListStyles,
        onClick: onImageListClick
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BasicBlock/* BasicBlock */.M, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: basicInfoBlockStyle,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header/* Header */.h, {
          name: hotel.name,
          address: hotel.address,
          rating: hotel.rating
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description/* Description */.d, {
          description: hotel.description
        }), hotel.isEan ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Location, {
          address: hotel.address,
          name: hotel.name,
          latitude: hotel.latitude,
          longitude: hotel.longitude
        }) : ""]
      })
    }), !selectedHotelPlan ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelRoomList, {}) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelRoomListWithSelectedPlan, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BasicBlock/* BasicBlock */.M, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelDetails, {
        hotel: hotel
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BasicBlock/* BasicBlock */.M, {
      styles: MainStyle.reviewListBlock,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReviewList, {
        reviews: hotel.googleReviews,
        rating: hotel.rating
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelImageModal, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelRoomDetailModal, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchModalDialog/* SearchModalDialog */.D, {
      displayed: isDynamicPackage && isExpired,
      refreshHandler: refreshHandler
    })]
  });
};

var HotelShowMain_areEqual = function areEqual(prevProps, nextProps) {
  return react_fast_compare_default()(prevProps, nextProps);
};

var HotelShowMain = /*#__PURE__*/react.memo(HotelShowMainComponent, HotelShowMain_areEqual);
var imageBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("cursor:pointer;padding:0 0 ", spaceStyle/* space.block2x */.D.block2x, " 0;max-width:100%;box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0);
var imageListBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:0 0 ", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var basicInfoBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("margin:-", spaceStyle/* space.atom */.D.atom, " 0;" + ( true ? "" : 0),  true ? "" : 0); // const reviewListBlockStyle = css`
//   padding: 0 ${space.atom} ${space.atom3x} ${space.atom};
//   &:before {
//     content: "";
//     display: block;
//     border-top: 1px solid ${accentColor.primaryColor};
//     margin: 0 ${space.atom} ${space.atom3x};
//   }
// `;
// const stepIndicatorBlockStyle = css`
//   padding-bottom: ${space.atom3x};
// `;
// EXTERNAL MODULE: ./main/javascripts/components/footer/Footer.tsx
var Footer = __webpack_require__(77747);
// EXTERNAL MODULE: ./main/javascripts/utils/DebugUtil.tsx
var DebugUtil = __webpack_require__(92494);
;// CONCATENATED MODULE: ./pages/hotels/[hotelId].tsx




















(0,DebugUtil/* loadVConsole */.W)(2000);

function HotelShow(props) {
  var hotel = props.hotel,
      param = props.param,
      locale = props.locale,
      origin = props.origin;
  var noindex = hotel.noindex || false;
  (0,useUserAccount/* useUserAccount */.q)(store/* store */.h, true);
  (0,useConstructor/* useConstructor */.g)(function () {
    store/* store.dispatch */.h.dispatch((0,hotelSlice/* initHotel */.ZH)(hotel)); // RTK

    store/* store.dispatch */.h.dispatch((0,paramSlice/* initHotelShowParam */.nR)((0,humps.camelizeKeys)(param))); // RTK

    store/* store.dispatch */.h.dispatch((0,Constants/* initConstants */.M)(props));

    if (i18n/* default.language */.Z.language !== locale) {
      void i18n/* default.changeLanguage */.Z.changeLanguage(locale);
    }

    globalStyle/* extended.css */.bU.css(globalStyle/* defaultStyles */.jF[globalStyle/* GLOBALS */.UH]);
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(es/* Provider */.zt, {
    store: store/* store */.h,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelHead/* HotelHead */.P, {
      origin: origin,
      hotelName: hotel.name,
      noindex: noindex
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(I18nextProvider/* I18nextProvider */.a, {
      i18n: i18n/* default */.Z,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderContainer/* HeaderContainer */.g, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HotelShowMain, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* Footer */.$, {})]
      })
    })]
  });
}

var __N_SSP = true;
/* harmony default export */ var _hotelId_ = (HotelShow);

/***/ }),

/***/ 62890:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hotels/[hotelId]",
      function () {
        return __webpack_require__(96786);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,8053,9481,9113,5057,1906,2912,9923,4170,4602,2802,853,1664,7744,9224,7993,5642,4349,6129,8740,9918,5147,4750,1185,5284,6852,5543,8452,6161,855,8737,2888,179], function() { return __webpack_exec__(62890); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);